// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:07:15.681Z
// Property: Aspen Creek (ID: 5672714597564416)
// Collections: 49 amenities, 13 floorplans (live), 26 photos, 66 POIs, 5 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5672714597564416",
  "property_external_id": "978668",
  "property_zillow_url": "https://www.zillow.com/apartments/kirkland-wa/aspen-creek/5XjT8r/",
  "property_apartments_url": "https://www.apartments.com/aspen-creek-kirkland-wa/kpsklyb/",
  "property_google_business_url": "https://www.google.com/maps/place/Aspen+Creek/data=!4m2!3m1!1s0x0:0x4173988950eb6267?sa=X&ved=2ahUKEwjD6ILNlriSAxXtEEQIHY-KGU0Q_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "aspen-creek",
  "property_name": "Aspen Creek",
  "property_website_url": "https://www.aspencreekapartmenthomes.com/",
  "property_domain": "https://www.aspencreekapartmenthomes.com",
  "property_address": "11101 - 123rd Lane NE",
  "property_full_address": "11101 - 123rd Lane NE, Kirkland, WA 98033",
  "property_address_1": "11101 - 123rd Lane NE",
  "property_address_2": null,
  "property_address_city": "Kirkland",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98033",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "North Rose Hill",
  "property_address_latitude": "47.6997596",
  "property_address_longitude": "-122.1763842",
  "property_email": "aspencreek@weidner.com",
  "property_phone": "425-256-4010",
  "property_call_tracking_phone": "425-256-4010",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at Aspen Creek in Kirkland, WA! Choose from spacious one, two, or three-bedroom floor plans designed for comfort. Enjoy premium amenities like a resident lounge, coffee station, and planned social activities. Find your new home today—browse our availability or schedule a tour to experience our community!",
  "property_long_description": "<p>If you're searching for apartments for rent in Kirkland, WA, Aspen Creek delivers comfort and convenience. Experience a pet-friendly community designed for vibrant living steps from shopping, parks, and dining. Enjoy in-home features that bring both style and function to your daily routine, like cozy fireplaces, your own washer and dryer, and a private balcony or patio. Aspen Creek also offers unique townhome layouts and rentable garages for extra storage and a true neighborhood-like setting. </p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a1-3b7a-714c-87a2-83a48c0cda72.webp",
  "property_featured_image_media": {
    "alt_text": "Lobby seating area with comfortable chairs, modern decor, and a fireplace.",
    "public_id": "019d01a1-3b7a-714c-87a2-83a48c0cda72",
    "storage_key": "property/5672714597564416/019d01a1-3b7a-714c-87a2-83a48c0cda72.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "149",
  "property_year_built": "1995",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.63087248322147",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://aspencreekapartmenthomes.securecafe.com/onlineleasing/aspen-creek-3/floorplans.aspx",
  "property_resident_portal_url": "https://aspencreekapartmenthomes.securecafenet.com/residentservices/aspen-creek-3/userlogin",
  "property_apply_now_url": "https://aspencreekapartmenthomes.securecafe.com/onlineleasing/aspen-creek-3/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-5429-7000-9329-5afa34056d53.webp",
  "property_primary_logo_media": {
    "alt_text": "Aspen Creek Apartment Homes logo",
    "public_id": "019d019f-5429-7000-9329-5afa34056d53",
    "storage_key": "property/5672714597564416/019d019f-5429-7000-9329-5afa34056d53.webp",
    "width": 1836,
    "height": 745
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a1-307b-74cd-ab74-630f7232de63.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d01a1-307b-74cd-ab74-630f7232de63",
    "storage_key": "property/5672714597564416/019d01a1-307b-74cd-ab74-630f7232de63.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a1-4862-74c8-b20e-9788e0bb4b56.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Aspen Creek Apartment Homes logo",
    "public_id": "019d01a1-4862-74c8-b20e-9788e0bb4b56",
    "storage_key": "property/5672714597564416/019d01a1-4862-74c8-b20e-9788e0bb4b56.webp",
    "width": 640,
    "height": 260
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a1-534c-718f-9d9b-a00a18127382.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Aspen Creek Apartment Homes logo.",
    "public_id": "019d01a1-534c-718f-9d9b-a00a18127382",
    "storage_key": "property/5672714597564416/019d01a1-534c-718f-9d9b-a00a18127382.webp",
    "width": 640,
    "height": 260
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#8b1920",
  "property_secondary_color": "#98772a",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#201d1e",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": " - 1495",
  "property_sqft_min": "773",
  "property_sqft_max": "1495",
  "property_price_range": "2040 - 3621",
  "property_price_min": "2040",
  "property_price_max": "3621",
  "property_available_units": 19,
  "property_facebook_url": "https://www.facebook.com/AspenCreekApartmentHomes/",
  "property_instagram_url": "https://www.instagram.com/aspencreekapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJm7aNBH4NkFQRZ2LrUImYc0E",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Aspen Creek",
  "property_home_romance_title": "Embrace a Vibrant Life at Your New Apartment Home!",
  "property_home_amenities_blurb": "Welcome to Aspen Creek in Kirkland, WA, where comfort meets style. Choose from an array of one, two, or three-bedroom apartments featuring stunning skylights, vaulted ceilings, and modern stainless steel appliances. Enjoy our vibrant community amenities, including a sparkling pool, fitness center, and pet-friendly play areas. Seize the day with us!",
  "property_home_floorplans_blurb": "Welcome to Aspen Creek in beautiful Kirkland, WA, where comfort meets style. Choose from our thoughtfully designed one, two, or three-bedroom apartments, each crafted for modern living. Embrace a vibrant community and serene surroundings—your ideal home awaits. Browse our available floor plans today to start your new adventure!",
  "property_home_gallery_blurb": "Welcome to Aspen Creek in vibrant Kirkland, WA, where spacious one, two, and three-bedroom apartments meet extraordinary amenities. Enjoy leisurely afternoons by the pool, workouts in the fitness center, or socializing at our on-site lounge. With pet-friendly spaces and stunning waterfront views, your perfect home awaits. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Aspen Creek in beautiful Kirkland, WA! Discover your perfect home with our spacious floor plans, featuring one, two, and three-bedroom apartments. Explore the vibrant neighborhood to uncover local favorites and nearby points of interest—see what's around our community today! Your ideal lifestyle awaits!",
  "property_home_reviews_blurb": "Nestled in the serene wetlands of Kirkland, Aspen Creek is lauded for its exceptional community vibe, where \"office staff are professional, empathic, engaging, and fun.\" Residents enjoy well-appointed, cozy units and a calendar filled with thoughtful events. Experience living where your happiness truly matters—join us today!",
  "property_neighborhood_blurb": "At Aspen Creek in Kirkland, WA, vibrant living meets a thriving community. Nestled near esteemed institutions like Lake Washington Institute of Technology and DigiPen, our residents enjoy access to top-notch schools and engaging recreational spaces, including Lake Washington CrossFit and local fitness centers. Experience a captivating lifestyle filled with culture and convenience.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Discover the vibrant lifestyle at Aspen Creek in Kirkland, WA! Our diverse floor plans—one, two, and three bedrooms—are enhanced by exceptional amenities, including a resident lounge, smoke-free spaces, and energy-efficient appliances. Explore our amazing community amenities and apartment features, and find your new home today!",
  "property_applynow_blurb": "Welcome to Aspen Creek in Kirkland, WA! Our diverse floor plans—one, two, and three-bedroom apartments—offer spacious living with modern amenities. Enjoy planned social activities, a resident lounge, and energy-efficient appliances. Don’t wait - find your new home and lease online today! ",
  "property_contactus_blurb": "Discover your ideal home at Aspen Creek in Kirkland, WA! Our diverse floor plans include one, two, and three-bedroom options to suit your lifestyle. Curious about our unique layouts? View all available designs. Have questions? Contact our leasing team today for personalized assistance and find your perfect apartment!",
  "property_faqs_blurb": "Welcome to Aspen Creek in Kirkland, WA, where stylish living meets comfort! Explore our variety of floor plans, including one, two, and three-bedroom apartments. Have questions? Browse our FAQs page to discover everything you need to know about our vibrant community and find the perfect home for you!",
  "property_floorplans_blurb": "Discover your ideal living space at Aspen Creek in Kirkland, WA! Choose from our thoughtfully designed floor plans, including one, two, and three-bedroom apartments. Each layout offers comfort and style tailored to your lifestyle. Browse our available apartment homes today and find your perfect floor plan!",
  "property_gallery_blurb": "Discover your dream home at Aspen Creek in Kirkland, WA! Choose from stylish one, two, or three-bedroom floor plans, complete with modern amenities like a resident lounge, coffee station, and energy-efficient appliances. Picture yourself living here! Explore our photo gallery to see the vibrant community and spacious living spaces.",
  "property_interactivemap_blurb": "Explore Aspen Creek in beautiful Kirkland, WA, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans featuring walk-in closets and white kitchen appliances. Enjoy amenities like a resident lounge, cardio equipment, and planned social activities. Use our interactive community map to find your new home today!",
  "property_pets_blurb": "Nestled in the heart of Kirkland, Aspen Creek invites you to experience a perfect blend of comfort and style. With spacious layouts and lush surroundings, your new home is just minutes from the vibrant waterfront. Plus, our pet-friendly policy ensures your furry companions can enjoy the lifestyle too!",
  "property_referafriend_blurb": "Discover your perfect home at Aspen Creek in Kirkland, WA! Choose from spacious one, two, and three-bedroom floor plans tailored for comfort and style. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy the perks of living alongside your favorite people! View all floor plans now!",
  "property_residentaccess_blurb": "Welcome to Aspen Creek in Kirkland, WA! Explore our inviting one, two, and three-bedroom floor plans designed for your comfort. Don’t forget to access your resident portal to easily pay rent, schedule maintenance, and enjoy a seamless living experience. Join our vibrant community today!",
  "property_reviews_blurb": "At Aspen Creek in Kirkland, WA, residents experience a vibrant community where “the office staff are professional, empathic, engaging, and fun.” With cozy units, spacious kitchens, and serene wetlands, you’ll find every detail is designed for comfort. Join our lively events and feel at home in a space that truly cares!",
  "property_created_at": "1752256467316",
  "property_scheduletour_blurb": "Discover your perfect home at Aspen Creek in Kirkland, WA! Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Ready to find your ideal space? Schedule a tour today and see what our residents are saying about life in our welcoming community!",
  "property_thankyou_blurb": "Thank you for your interest in Aspen Creek, the perfect apartment community in Kirkland, WA! Explore our diverse floor plans, including one, two, and three-bedroom options tailored to your lifestyle. A team member will reach out shortly to assist you in finding your dream home. Stay tuned!",
  "property_virtualtours_blurb": "Discover your perfect home at Aspen Creek in Kirkland, WA! Explore our diverse floor plans, including one, two, and three-bedroom apartments. Experience the charm of our community—take a virtual tour today and envision your future here! Don’t wait; your dream apartment awaits!",
  "property_copyright": "2025 All Rights Reserved. Aspen Creek",
  "property_seo_title_home": "Aspen Creek | Apartments in Kirkland, WA",
  "property_seo_description_home": "Discover your perfect home at Aspen Creek in Kirkland, WA! Explore our diverse floor plans, including one, two, and three-bedroom apartments, tailored to fit your lifestyle. Enjoy exceptional amenities like a resident lounge, state-of-the-art fitness center, and planned social activities designed for community living. With energy-efficient appliances, walk-in closets, and modern white kitchen finishes, your new apartment awaits! Find your new home today at Aspen Creek, where comfort meets convenience.",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Kirkland, WA",
  "property_seo_description_floorplans": "Discover your ideal living space at Aspen Creek in Kirkland, WA! Explore our diverse floor plans, featuring cozy one-bedroom, spacious two-bedroom, and family-friendly three-bedroom apartments. Whether you're seeking comfort or luxury, we have the perfect layout for you. Browse our available apartment homes and find your perfect floor plan today!",
  "property_seo_title_amenities": "Amenities | Kirkland, WA Apartments for Rent",
  "property_seo_description_amenities": "Discover the perfect blend of comfort and style at Aspen Creek in Kirkland, WA! Explore our thoughtfully designed apartment floor plans, featuring one, two, and three bedrooms, all equipped with modern amenities. Enjoy a vibrant lifestyle with planned social activities, a cozy resident lounge, a coffee station, and state-of-the-art fitness facilities. Experience the luxury of walk-in closets, energy-efficient appliances, and more! Join our smoke-free community and elevate your living experience. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Kirkland, WA",
  "property_seo_description_gallery": "Discover the life you deserve at Aspen Creek in Kirkland, WA! Explore our vibrant photo gallery showcasing spacious floor plans with one, two, and three-bedroom options. Experience exceptional amenities like a resident lounge, coffee station, and well-equipped fitness center. Imagine hosting your friends at our planned social activities or enjoying the tranquility of your smoke-free home adorned with energy-efficient appliances and walk-in closets. Picture yourself living here—your perfect apartment awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Aspen Creek Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Aspen Creek in Kirkland, WA! Explore our spacious one, two, and three-bedroom apartments through a virtual tour. See why our community stands out with diverse floor plans designed for modern living. Take a virtual tour today and find your ideal space!",
  "property_seo_title_interactivemap": "Interactive Map | Aspen Creek Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Aspen Creek in Kirkland, WA! Explore our spacious one, two, and three-bedroom floor plans, complete with modern amenities like cardio machines, a resident lounge, and a coffee station. Enjoy planned social activities, energy-efficient appliances, and smoke-free living. Use our interactive community map to find available apartments, view pricing, and secure your perfect living space today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Kirkland, WA",
  "property_seo_description_neighborhood": "Discover the vibrant lifestyle at Aspen Creek in Kirkland, WA! Explore our diverse floor plans, including spacious one, two, and three-bedroom apartments. Visit our Neighborhood page to see what's around our community and uncover local favorites and nearby attractions. Your new home awaits at Aspen Creek!",
  "property_seo_title_contact": "Contact Us | Aspen Creek",
  "property_seo_description_contact": "Discover your perfect home at Aspen Creek in Kirkland, WA! Explore our diverse floor plans, including cozy one-bedroom, spacious two-bedroom, and family-friendly three-bedroom apartments. Have questions? Contact our leasing team today and let us help you find your ideal living space!",
  "property_seo_title_faqs": "FAQs | Apartments in Kirkland, WA",
  "property_seo_description_faqs": "Explore the Aspen Creek community in Kirkland, WA, where comfort meets style! Discover our diverse range of two, one, and three-bedroom floor plans, enhanced by top-notch amenities including a resident lounge, planned social activities, and a convenient coffee station. Enjoy features like walk-in closets, energy-efficient appliances, and stunning skylights*. Have questions? Browse our FAQs page to find answers about our smoke-free, amenity-rich living at Aspen Creek. Your ideal home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kirkland, WA",
  "property_seo_description_reviews": "Discover the charm of Aspen Creek in Kirkland, WA! Explore our variety of spacious floor plans, from cozy one-bedroom to expansive three-bedroom apartments. Enjoy premium amenities, including a resident lounge, cardio and weight machines, and a delightful coffee station. Plus, experience community life with our planned social activities. Want to know more? See what our residents have to say about their experience at Aspen Creek!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kirkland, WA",
  "property_seo_description_applynow": "Discover your perfect home at Aspen Creek in Kirkland, WA! Explore our spacious one, two, and three-bedroom floor plans designed for modern living. Enjoy an array of top-notch amenities including a resident lounge, coffee station, and planned social activities, along with energy-efficient appliances and convenient walk-in closets. Ready to elevate your lifestyle? Apply now and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Aspen Creek",
  "property_seo_description_residentaccess": "\"Welcome to Aspen Creek in Kirkland, WA! Log in to your resident portal for easy access to pay rent, request maintenance, and manage your living experience. Enjoy seamless convenience at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | Aspen Creek",
  "property_seo_description_referafriend": "\"Share the love at Aspen Creek in Kirkland, WA! Refer a friend to our vibrant apartment community and enjoy exclusive rewards. Great friends make great neighbors—start building your ideal living environment today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Aspen Creek",
  "property_seo_description_scheduletour": "Discover your new home at Aspen Creek in Kirkland, WA! Experience spacious living and stunning amenities in our welcoming apartment community. Schedule a tour today and explore your future home!",
  "property_seo_title_privacy": "Privacy Policy | Aspen Creek",
  "property_seo_description_privacy": "\"Discover Aspen Creek in Kirkland, WA—your perfect home awaits! Explore our commitment to your privacy with our detailed privacy policy. Learn how we protect your personal information and enjoy peace of mind. View our privacy policy now!\"",
  "property_seo_title_accessibility": "Website Accessibility | Aspen Creek",
  "property_seo_description_accessibility": "\"Discover Aspen Creek in Kirkland, WA—where accessibility matters! Explore our commitment to digital inclusion and inclusive living for all. Join us in creating a welcoming community that values every resident. Learn more today!\"",
  "property_seo_title_sitemap": "Sitemap | Aspen Creek",
  "property_seo_description_sitemap": "Discover the complete Aspen Creek experience in Kirkland, WA! Explore our sitemap to easily navigate all the features, amenities, and available apartments in our vibrant community. View our website sitemap today and find your perfect home at Aspen Creek!",
  "property_seo_title_thankyou": "Thank You | Aspen Creek",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Aspen Creek in Kirkland, WA! Your inquiry is important to us. A member of our dedicated team will contact you shortly to assist with your apartment needs. Discover comfortable living at Aspen Creek!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Kirkland, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793119460473",
  "amenities": [
    {
      "id": "ec_e23c77c718082e8c05a6db12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769200",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7686d560241217e3ee598c77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769202",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_873a8e8e002f9baf5582c8d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769322",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f5b037c310d23319a2b62bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769323",
      "title": "Seasonal Barbecue/ Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8f74922a124bb644ff6db5e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769324",
      "title": "Fitness Center",
      "amount": "false",
      "description": "Fitness Center is open 24 hours a day",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84a9c21ee29cfc69b570176d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769325",
      "title": "Seasonal Pool & Hot Spa",
      "amount": "false",
      "description": "Pool is outdoor, seasonal",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f38dd5fa98bc1ab62118e7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769204",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc7807c7462f19d0c009ae7e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769320",
      "title": "Coffee Station",
      "amount": "false",
      "description": "Fresh cookies made daily",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a65d53498f903e86b560fc2d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769321",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-42d6-76ea-b939-32eee80bd440.webp",
      "amenity_image_media": {
        "alt_text": "Clubhouse living room with fireplace, comfortable seating, and large windows.",
        "public_id": "019d019f-42d6-76ea-b939-32eee80bd440",
        "storage_key": "property/5672714597564416/019d019f-42d6-76ea-b939-32eee80bd440.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Aspen Creek Resident Lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c5519c703015db724b3ca40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "124800083",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9291c95cfc7c1ffd7d54d7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769327",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a03225-9398-74c8-b5b8-d74ea435a35f.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills and elliptical in the fitness center.",
        "public_id": "01a03225-9398-74c8-b5b8-d74ea435a35f",
        "storage_key": "property/5672714597564416/01a03225-9398-74c8-b5b8-d74ea435a35f.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Aspen Creek Gym",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_434a5b8307552b1a8641ec27",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769328",
      "title": "Weight Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49aeb1899852d978bcb63884",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "128984197",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72e80c8ca1c5dc1054e0a7ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731645",
      "title": "Outside Storage*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff17a7fdae6a97bbabb23440",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769338",
      "title": "Fireplace",
      "amount": "false",
      "description": "All homes have wood burning fireplaces",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d99d2-7cd6-703a-93d8-a79b07bff8c8.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace, stairs, and kitchen area. Renovated.",
        "public_id": "019d99d2-7cd6-703a-93d8-a79b07bff8c8",
        "storage_key": "property/5672714597564416/019d99d2-7cd6-703a-93d8-a79b07bff8c8.webp",
        "width": 960,
        "height": 540
      },
      "amenity_image_alt_text": "a living room with a fireplace and a staircase,a home with carpeted stairs and a dining room with a table and chairs",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3e6b2245ecd857739a28bb7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769333",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d99d2-7cbb-77c9-af4d-2adb893c346d.webp",
      "amenity_image_media": {
        "alt_text": "Renovated kitchen with white cabinets, granite countertops, stainless steel appliances, and a sink.",
        "public_id": "019d99d2-7cbb-77c9-af4d-2adb893c346d",
        "storage_key": "property/5672714597564416/019d99d2-7cbb-77c9-af4d-2adb893c346d.webp",
        "width": 960,
        "height": 540
      },
      "amenity_image_alt_text": "a kitchen with white cabinets and granite counter tops,a kitchen with white appliances and wooden cabinets",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0fb4ea40bae48c7bfb1b2a06",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769342",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "all homes have washer/dryer",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d99d2-7b6d-7633-82c7-be880fdd5b54.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer in laundry closet, with a staircase in the background.",
        "public_id": "019d99d2-7b6d-7633-82c7-be880fdd5b54",
        "storage_key": "property/5672714597564416/019d99d2-7b6d-7633-82c7-be880fdd5b54.webp",
        "width": 960,
        "height": 540
      },
      "amenity_image_alt_text": "a laundry room with a washer and dryer,a laundry room with a washer and dryer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5be3c2c0ee78f8486e3abd69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769331",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1b36d157aeece52e19a25e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769330",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_078536448922e4c5dfb67ac4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769332",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54c0f1bdc5bb3d2e702723a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769335",
      "title": "Electric Stove",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a68616f09c72d7553e9e7e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769336",
      "title": "Baseboard Heat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da86f3cb51743e47490cccdf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769337",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f86fa85fed0e77017ef9ebc2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769339",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "If it is a top floor only home it will have a balcony,otherwise townhomes have patios",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_569efde61d9c3b7d3d157e86",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769340",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "Some bedrooms have pitched/vaulted ceilings, all ceilings are at least 9'",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_617911cacc892e52f8ab311b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769341",
      "title": "Views",
      "amount": "false",
      "description": "some have wetland views",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0ba02ef513fbbfccf1d681d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769345",
      "title": "Linen Closet*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32ae28c55fb8dd2b5d50c273",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "122653286",
      "title": "White Kitchen Appliances*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d91f10412d3338581d61bfb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769334",
      "title": "Ice Maker*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c19511e77a8fbce8f06b66f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769344",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1421f6d85154bcd3d636990c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769347",
      "title": "Sprinkler System*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3a78bd838182ce6b5740df6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769348",
      "title": "Walk-In Closets*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f2398f864f458d1aca30371",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769349",
      "title": "Skylights*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_578128ba7d2eb730e139e230",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "86769350",
      "title": "Energy Efficient Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c6cd4893bfcb717509f5fca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731620",
      "title": "White Cabinets",
      "amount": "false",
      "description": "White Cabinets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2a55020b3c40978a2db9627",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731629",
      "title": "Accessible",
      "amount": "false",
      "description": "Handicap Accessible Unit",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_134aabc96aad4209bf72d968",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731631",
      "title": "Corner Unit*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31a220af570caf4b43346cd0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731632",
      "title": "Extra Large Closet",
      "amount": "false",
      "description": "Unit has extra large closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_284f8ccf44cace174d572d0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731633",
      "title": "First Floor Vinyl*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4fa584b1415387fa58683c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731636",
      "title": "Floor Level 2",
      "amount": "false",
      "description": "Unit is on floor level 2",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbf08c51c7739ad736450a1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731642",
      "title": "Kitchen Upgrade",
      "amount": "false",
      "description": "Unit has upgraded kitchen",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_024367e9b89a719a5506063c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731648",
      "title": "Upgraded Paint",
      "amount": "false",
      "description": "Unit's paint has been upgraded",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c68bb113b57b0d51f95f8f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731649",
      "title": "View Wetlands/Greenbelt*",
      "amount": "false",
      "description": "*Select units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc7f749647128a45296f5af9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126731651",
      "title": "Vinyl Flooring Throughout",
      "amount": "false",
      "description": "Vinyl Flooring Throughout Unit",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81e73b1fbf96225c0fa65b61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126925317",
      "title": "Remodel 1",
      "amount": "false",
      "description": "Remodeled Unit",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a89991d6cc2defe15e6524b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "126925318",
      "title": "Remodel 2",
      "amount": "false",
      "description": "Remodeled unit type 2",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_defb83493ba6c224778184c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "127864131",
      "title": "Location - View",
      "amount": "false",
      "description": "Location - View",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd402fb5066b46d7a569d328",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "127864132",
      "title": "Location - Parking",
      "amount": "false",
      "description": "Location - Parking",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f92aee45ea30b29d4077490f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "yardi",
      "external_id": "127864133",
      "title": "Balcony",
      "amount": "false",
      "description": "Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_df0ac824842ebcad617973b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02cff-8b20-720f-84e9-9f92205a28b5.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry area with living room and fireplace visible.",
        "public_id": "01a02cff-8b20-720f-84e9-9f92205a28b5",
        "storage_key": "property/5672714597564416/01a02cff-8b20-720f-84e9-9f92205a28b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience, adjacent to a cozy living area with a fireplace.",
      "link": "false",
      "alt_text": "Washer and dryer in laundry area with living room and fireplace visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (53).jpg"
    },
    {
      "id": "ec_0507520acf48bbf2a32f7ad6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02cff-cdcc-77dc-8870-5758df7c1266.webp",
      "image_media": {
        "alt_text": "Spacious living room with fireplace, large windows, and comfortable seating.",
        "public_id": "01a02cff-cdcc-77dc-8870-5758df7c1266",
        "storage_key": "property/5672714597564416/01a02cff-cdcc-77dc-8870-5758df7c1266.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Elegant living room featuring a cozy fireplace, large windows offering abundant natural light, and plush seating perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with fireplace, large windows, and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (52).jpg"
    },
    {
      "id": "ec_316bfdc913045b97c6f85753",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02cff-df6f-701d-8290-f5aae54a7281.webp",
      "image_media": {
        "alt_text": "A kitchen with dark wood cabinets, black appliances, and a mosaic tile backsplash.",
        "public_id": "01a02cff-df6f-701d-8290-f5aae54a7281",
        "storage_key": "property/5672714597564416/01a02cff-df6f-701d-8290-f5aae54a7281.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, a mosaic tile backsplash, and modern black appliances including a refrigerator, oven, and microwave.",
      "link": "false",
      "alt_text": "A kitchen with dark wood cabinets, black appliances, and a mosaic tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (51).jpg"
    },
    {
      "id": "ec_cad55cbd33f15c7de76cc786",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02cff-cdcf-76fc-92fb-c50182b3ea1d.webp",
      "image_media": {
        "alt_text": "Walkway leading to apartment building entrances with manicured hedges and trees.",
        "public_id": "01a02cff-cdcf-76fc-92fb-c50182b3ea1d",
        "storage_key": "property/5672714597564416/01a02cff-cdcf-76fc-92fb-c50182b3ea1d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with a walkway, mature landscaping, and welcoming entrances. Showcasing the community's attractive exterior and pathways.",
      "link": "false",
      "alt_text": "Walkway leading to apartment building entrances with manicured hedges and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (50).JPG"
    },
    {
      "id": "ec_e6c7ca4ecd2e765be1b8a17f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02cff-defe-71b7-8069-b27a26373147.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dual sinks, large mirror, and shower stall.",
        "public_id": "01a02cff-defe-71b7-8069-b27a26373147",
        "storage_key": "property/5672714597564416/01a02cff-defe-71b7-8069-b27a26373147.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, dual sinks, and a large mirror. Includes a separate shower stall for convenience.",
      "link": "false",
      "alt_text": "Bathroom vanity with dual sinks, large mirror, and shower stall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (49).jpg"
    },
    {
      "id": "ec_82d4bfc91f0f6cba00412cfd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02cff-bea2-739e-8448-f8cea74f6ce5.webp",
      "image_media": {
        "alt_text": "A well-furnished bedroom with a queen-size bed, mirrored closet, and large window.",
        "public_id": "01a02cff-bea2-739e-8448-f8cea74f6ce5",
        "storage_key": "property/5672714597564416/01a02cff-bea2-739e-8448-f8cea74f6ce5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this spacious bedroom, featuring a cozy queen-size bed, ample closet space, and natural light from the large window.",
      "link": "false",
      "alt_text": "A well-furnished bedroom with a queen-size bed, mirrored closet, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (48).jpg"
    },
    {
      "id": "ec_e16cbeb918c7d0cc785e1c2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-2367-76a5-a4b3-958209b61e2c.webp",
      "image_media": {
        "alt_text": "Bunk bed with desk and seating in a child's bedroom.",
        "public_id": "01a02d00-2367-76a5-a4b3-958209b61e2c",
        "storage_key": "property/5672714597564416/01a02d00-2367-76a5-a4b3-958209b61e2c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and functional bunk bed setup with an integrated desk and seating, perfect for a child's room. Features colorful wall art and soft carpeting.",
      "link": "false",
      "alt_text": "Bunk bed with desk and seating in a child's bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (47).jpg"
    },
    {
      "id": "ec_78a7c78b41b40aabb487b56a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-3808-741f-afd6-3f500dda6036.webp",
      "image_media": {
        "alt_text": "Living room and dining area with stairs in a multifamily property.",
        "public_id": "01a02d00-3808-741f-afd6-3f500dda6036",
        "storage_key": "property/5672714597564416/01a02d00-3808-741f-afd6-3f500dda6036.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with plush carpeting, a cozy seating area, and a staircase leading to the upper level. Ideal for comfortable living.",
      "link": "false",
      "alt_text": "Living room and dining area with stairs in a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (46).jpg"
    },
    {
      "id": "ec_adeec2b7a4c15eda5192b3c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-26e8-746c-afb1-435c56e22092.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machine in a fitness center.",
        "public_id": "01a02d00-26e8-746c-afb1-435c56e22092",
        "storage_key": "property/5672714597564416/01a02d00-26e8-746c-afb1-435c56e22092.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, an elliptical, and more.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machine in a fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (45).JPG"
    },
    {
      "id": "ec_078ba5fada575efe06fce604",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-2748-72e9-9f73-d459d147e6d5.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with storage shelf above.",
        "public_id": "01a02d00-2748-72e9-9f73-d459d147e6d5",
        "storage_key": "property/5672714597564416/01a02d00-2748-72e9-9f73-d459d147e6d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with storage shelf above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (44).jpg"
    },
    {
      "id": "ec_a12545f9dcdf463319ffa752",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-4234-743e-a93f-f0f3888ec53d.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower with a decorative curtain.",
        "public_id": "01a02d00-4234-743e-a93f-f0f3888ec53d",
        "storage_key": "property/5672714597564416/01a02d00-4234-743e-a93f-f0f3888ec53d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and tidy bathroom featuring a single vanity with a sink, a toilet, and a bathtub with a decorative shower curtain. Includes a mirror and towels.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and shower with a decorative curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (43).jpg"
    },
    {
      "id": "ec_4208f2faf72d2b79cc8c8e2f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-7c0c-7296-980d-627055f24d33.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral gray walls, plush carpet, and multiple closets.",
        "public_id": "01a02d00-7c0c-7296-980d-627055f24d33",
        "storage_key": "property/5672714597564416/01a02d00-7c0c-7296-980d-627055f24d33.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This spacious bedroom features soft gray walls, comfortable carpeting, and ample closet space, providing a serene and functional living area.",
      "link": "false",
      "alt_text": "Empty bedroom with neutral gray walls, plush carpet, and multiple closets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (42).jpg"
    },
    {
      "id": "ec_ca757eb987851c81acb25545",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-9c8c-708d-95e3-1973ec55a674.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, mirrored closet doors, and a tall shelf.",
        "public_id": "01a02d00-9c8c-708d-95e3-1973ec55a674",
        "storage_key": "property/5672714597564416/01a02d00-9c8c-708d-95e3-1973ec55a674.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ample closet space with mirrored doors, and decorative shelving. A full-length mirror reflects the room's inviting ambiance.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, mirrored closet doors, and a tall shelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (41).jpg"
    },
    {
      "id": "ec_c374b791c414e7e9d04cb6ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-75df-71e2-be02-161da8399bb8.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances including a dishwasher, microwave, and oven, and a stainless steel sink.",
        "public_id": "01a02d00-75df-71e2-be02-161da8399bb8",
        "storage_key": "property/5672714597564416/01a02d00-75df-71e2-be02-161da8399bb8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this well-equipped kitchen featuring ample cabinet space, a dishwasher, microwave, and a spacious sink. Perfect for preparing meals and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white appliances including a dishwasher, microwave, and oven, and a stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (40).jpg"
    },
    {
      "id": "ec_1f5d8ba90fb95ce2df5796f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-7f33-72bf-af69-89a27e8e35f7.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks and large mirror",
        "public_id": "01a02d00-7f33-72bf-af69-89a27e8e35f7",
        "storage_key": "property/5672714597564416/01a02d00-7f33-72bf-af69-89a27e8e35f7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, dual sinks, and a large mirror, perfect for any apartment.",
      "link": "false",
      "alt_text": "Bathroom vanity with double sinks and large mirror",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (39).jpg"
    },
    {
      "id": "ec_60a60e2b7cc57e15e908ef05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-7bbc-7378-bfe3-2ae634e0c27e.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with plush carpet and a large arched window.",
        "public_id": "01a02d00-7bbc-7378-bfe3-2ae634e0c27e",
        "storage_key": "property/5672714597564416/01a02d00-7bbc-7378-bfe3-2ae634e0c27e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and inviting living area with soft carpeting and a beautiful arched window providing natural light.",
      "link": "false",
      "alt_text": "Empty apartment living room with plush carpet and a large arched window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (38).jpg"
    },
    {
      "id": "ec_5852d934e658a7c00d45392f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-cf50-77ba-8a66-42cb2e4fb8bc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a large sink.",
        "public_id": "01a02d00-cf50-77ba-8a66-42cb2e4fb8bc",
        "storage_key": "property/5672714597564416/01a02d00-cf50-77ba-8a66-42cb2e4fb8bc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring sleek white cabinetry, durable granite countertops, and a full suite of stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a large sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (37).jpg"
    },
    {
      "id": "ec_2c2354b0378d0f374be994c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-ef54-724d-90a6-8c2b5913ddef.webp",
      "image_media": {
        "alt_text": "Exterior of townhome garages with white doors and tan siding.",
        "public_id": "01a02d00-ef54-724d-90a6-8c2b5913ddef",
        "storage_key": "property/5672714597564416/01a02d00-ef54-724d-90a6-8c2b5913ddef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure your vehicle in one of our spacious garages, featuring convenient pull-up access and ample storage space.",
      "link": "false",
      "alt_text": "Exterior of townhome garages with white doors and tan siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (36).JPG"
    },
    {
      "id": "ec_928745485a9ecf18f0682e7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-c997-7206-803c-dde3937464e9.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and stairs",
        "public_id": "01a02d00-c997-7206-803c-dde3937464e9",
        "storage_key": "property/5672714597564416/01a02d00-c997-7206-803c-dde3937464e9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room with a fireplace and a view of the kitchen and stairs.",
      "link": "false",
      "alt_text": "Living room with fireplace and stairs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (35).jpg"
    },
    {
      "id": "ec_39338fa599c306a348bc9faa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-e070-701f-8037-fca93140b843.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and sliding glass doors",
        "public_id": "01a02d00-e070-701f-8037-fca93140b843",
        "storage_key": "property/5672714597564416/01a02d00-e070-701f-8037-fca93140b843.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and access to an outdoor patio or balcony.",
      "link": "false",
      "alt_text": "Living room with fireplace and sliding glass doors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (34).jpg"
    },
    {
      "id": "ec_15dc1bfe70d581560dee35da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d00-f868-727f-b5b3-39dd03a54385.webp",
      "image_media": {
        "alt_text": "Dining area with high-top table and four leather chairs.",
        "public_id": "01a02d00-f868-727f-b5b3-39dd03a54385",
        "storage_key": "property/5672714597564416/01a02d00-f868-727f-b5b3-39dd03a54385.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy casual dining in this stylish area, perfect for morning coffee or evening meals.",
      "link": "false",
      "alt_text": "Dining area with high-top table and four leather chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (33).jpg"
    },
    {
      "id": "ec_05ed2fee2af8fd0f1b4b6e5c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d01-0196-77e8-80b2-dd9de1b9377b.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with large windows and a ceiling fan.",
        "public_id": "01a02d01-0196-77e8-80b2-dd9de1b9377b",
        "storage_key": "property/5672714597564416/01a02d01-0196-77e8-80b2-dd9de1b9377b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area flows into a modern kitchen, perfect for entertaining. Large windows let in natural light, and a ceiling fan keeps the space cool.",
      "link": "false",
      "alt_text": "Living room and kitchen area with large windows and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (32).jpg"
    },
    {
      "id": "ec_010f054c12ce7ee655c9b718",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a02d01-0e14-721f-ba4b-5b0f6ca52271.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops open to a living room with a fireplace.",
        "public_id": "01a02d01-0e14-721f-ba4b-5b0f6ca52271",
        "storage_key": "property/5672714597564416/01a02d01-0e14-721f-ba4b-5b0f6ca52271.webp",
        "width": 3072,
        "height": 1785
      },
      "title": "Apartment",
      "description": "Stylish apartment featuring a modern kitchen with stainless steel appliances and granite countertops, flowing into a spacious living area with a cozy fireplace.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops open to a living room with a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (31).jpg"
    },
    {
      "id": "ec_2002191d7fad360f3c626b80",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019e-ab5b-76fc-a0ff-403fd943847f.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-size bed, nightstands, and a large arched window.",
        "public_id": "019d019e-ab5b-76fc-a0ff-403fd943847f",
        "storage_key": "property/5672714597564416/019d019e-ab5b-76fc-a0ff-403fd943847f.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this spacious bedroom, featuring a comfortable queen-size bed and ample natural light from the large arched window. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "A staged bedroom with a queen-size bed, nightstands, and a large arched window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (30).jpg"
    },
    {
      "id": "ec_ac546a81b8eadacbc5952a8f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a0374b-e65a-7349-94bf-2c8a03a84d42.webp",
      "image_media": {
        "alt_text": "Exterior of the rental office with double doors and surrounding landscaping.",
        "public_id": "01a0374b-e65a-7349-94bf-2c8a03a84d42",
        "storage_key": "property/5672714597564416/01a0374b-e65a-7349-94bf-2c8a03a84d42.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Welcome to the rental office, where our friendly staff is ready to assist you with leasing information and community details. Enjoy the beautiful landscaping and welcoming entrance.",
      "link": "false",
      "alt_text": "Exterior of the rental office with double doors and surrounding landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (55).jpg"
    },
    {
      "id": "ec_3f462e6ec04b49fa92841b20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/01a0374b-e65d-75a5-8b8d-3087899b3eca.webp",
      "image_media": {
        "alt_text": "Aspen Creek Apartment Homes monument sign with a horse logo and phone number.",
        "public_id": "01a0374b-e65d-75a5-8b8d-3087899b3eca",
        "storage_key": "property/5672714597564416/01a0374b-e65d-75a5-8b8d-3087899b3eca.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Welcome to Aspen Creek Apartment Homes. Discover our beautiful community and find your perfect home. Call us today!",
      "link": "false",
      "alt_text": "Aspen Creek Apartment Homes monument sign with a horse logo and phone number.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Aspen_Creek_Favorites (54).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2574e399-e039-4cd5-b0a9-e7f72a6a2453",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Kanishka Cuisine of India",
      "poi_type": "Restaurants",
      "poi_address": "16651 Redmond Wy Ste 180, Redmond, WA 98052, USA",
      "poi_short_description": "Broad menu featuring tandoori & veggie dishes in sizable restaurant with lunch buffet & happy hour.",
      "poi_long_description": "Diners say this Indian restaurant serves up delicious chicken tikka masala, butter chicken, garlic naan, and a standout lunch thali with a variety of vegetarian and non-vegetarian curries, rice, and samosas. They also highlight the friendly and attentive service, generous portions, and authentic flavors.\n\nSome reviews mention the food can be inconsistent in quality.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-f038-7747-a4f8-5a59678374e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-f038-7747-a4f8-5a59678374e0",
        "storage_key": "property/5672714597564416/019d019f-f038-7747-a4f8-5a59678374e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kanishkaredmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5446967398759314703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kanishka-cuisine-of-india",
      "poi_latitude": "47.6724413",
      "poi_longitude": "-122.117766",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-869-9182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c0f-71fc-b179-8494ae2a5236",
        "storage_key": "property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZS6Nkq1ykFQRD7Uuav2Dl0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_9f76e7b3-6631-4a17-9758-2250986864f1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Redmond Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7525 166th Ave NE, Redmond, WA 98052, USA",
      "poi_short_description": "2-level outdoor shopping plaza with stores, restaurants, lodging & entertainment.",
      "poi_long_description": "People say this shopping center offers a variety of restaurants, including Bon (본) Korean restaurant, and shops, with a clean and friendly atmosphere. They also highlight the outdoor design, ample parking, and family-friendly features like a splash fountain.\n\nSome reviews mention the center can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-fcb4-773e-9c34-c15709a89e3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-fcb4-773e-9c34-c15709a89e3c",
        "storage_key": "property/5672714597564416/019d019f-fcb4-773e-9c34-c15709a89e3c.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.redmondtowncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13753620862211367335&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "redmond-town-center",
      "poi_latitude": "47.6703851",
      "poi_longitude": "-122.120144",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c00-7028-8d95-49be54e2f600.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c00-7028-8d95-49be54e2f600",
        "storage_key": "property/5672714597564416/019d01a0-2c00-7028-8d95-49be54e2f600.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjYZ2uK9ykFQRp6GC602t3r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_80b7d536-4319-4b88-b386-9dfc571381b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "University of Washington Bothell",
      "poi_type": "Education",
      "poi_address": "17927 113th Ave NE, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-fe25-77cb-bd1a-b6f751dbcb33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-fe25-77cb-bd1a-b6f751dbcb33",
        "storage_key": "property/5672714597564416/019d019f-fe25-77cb-bd1a-b6f751dbcb33.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uwb.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14107547568998928606&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-bothell",
      "poi_latitude": "47.7584761",
      "poi_longitude": "-122.190891",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-352-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c2e-726e-8ea8-0bc6a3fbba48",
        "storage_key": "property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ46EtkWAOkFQR3lAb3sQTyMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b0803c80-48bc-40de-880a-b7a78351f6d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Lake Washington Institute of Technology",
      "poi_type": "Education",
      "poi_address": "11605 132nd Ave NE, Kirkland, WA 98034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-02c7-74ad-914e-710acf3c56bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-02c7-74ad-914e-710acf3c56bc",
        "storage_key": "property/5672714597564416/019d01a0-02c7-74ad-914e-710acf3c56bc.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.lwtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9688448915436613948&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-washington-institute-of-technology",
      "poi_latitude": "47.7046059",
      "poi_longitude": "-122.1669903",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-739-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c2e-726e-8ea8-0bc6a3fbba48",
        "storage_key": "property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeVTZ7XkNkFQRPDEe_fRIdIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_07a9066f-fa68-480e-881d-a0537c0b6ee9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Redmond Library",
      "poi_type": "Education",
      "poi_address": "15990 NE 85th St, Redmond, WA 98052, USA",
      "poi_short_description": "Warm, carpeted library featuring a large selection of books and DVDs, plus computers, quiet areas and free WiFi.",
      "poi_long_description": "People say this library offers a wide selection of books, including a young readers section, and provides spaces for quiet work and family time. They highlight the convenient community gathering place with reservable rooms, and the helpful staff. They also like the various activities, such as book hours and Taiko drumming shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-02a8-73bb-b689-2ac17ca24d96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-02a8-73bb-b689-2ac17ca24d96",
        "storage_key": "property/5672714597564416/019d01a0-02a8-73bb-b689-2ac17ca24d96.webp",
        "width": 1200,
        "height": 640
      },
      "poi_business_url": "https://kcls.org/locations/redmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10162122076226988230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "redmond-library",
      "poi_latitude": "47.6789086",
      "poi_longitude": "-122.1280775",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-885-1861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c2e-726e-8ea8-0bc6a3fbba48",
        "storage_key": "property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR0c4XE0NkFQRxiiq5S8cB40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_25acc458-491b-43d1-bd14-6c9d893534b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Kirkland Library",
      "poi_type": "Education",
      "poi_address": "308 Kirkland Ave, Kirkland, WA 98033, USA",
      "poi_short_description": "Well-maintained branch of King County libraries, featuring a children's zone, computers and free parking.",
      "poi_long_description": "People say this library offers a variety of books, including fiction and non-fiction, and provides spaces to work and bring children. They highlight the convenient location with nearby amenities, such as a playground, and the availability of printing services. They also like the helpful and kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-049d-758a-a426-f39cf1a136b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-049d-758a-a426-f39cf1a136b8",
        "storage_key": "property/5672714597564416/019d01a0-049d-758a-a426-f39cf1a136b8.webp",
        "width": 1200,
        "height": 640
      },
      "poi_business_url": "https://kcls.org/locations/kirkland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13242990867223347738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kirkland-library",
      "poi_latitude": "47.6760175",
      "poi_longitude": "-122.2029286",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-822-2459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c2e-726e-8ea8-0bc6a3fbba48",
        "storage_key": "property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2V7abt0SkFQRGgKXhAeOyLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_4fcfe514-8d37-4fb9-8a58-7f5f4385bd12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "KidsQuest Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "1116 108th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Interactive educational exhibits staged indoors & outdoors, plus workshops & summer camps.",
      "poi_long_description": "Visitors say this children's museum offers a variety of engaging activities, including a water play area, a grocery shopping pretend play section, and a dedicated area for toddlers. They also highlight the friendly and helpful staff, and the clean and well-maintained environment.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.kidsquestmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=565907723386877940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kidsquest-childrens-museum",
      "poi_latitude": "47.6208569",
      "poi_longitude": "-122.1959171",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 425-637-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f1f-768f-b2cb-37fcd3bdc10e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f1f-768f-b2cb-37fcd3bdc10e",
        "storage_key": "property/5672714597564416/019d01a0-2f1f-768f-b2cb-37fcd3bdc10e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc8TRNYxskFQR9PcffBOC2gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d444ee05-1ee5-4a92-bc3d-0ab92ac8d7ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Pop Keeney Stadium",
      "poi_type": "Entertainment",
      "poi_address": "9809 NE 188th St, Bothell, WA 98011, USA",
      "poi_short_description": "High school and other sporting events, plus graduations, are held at this stadium.",
      "poi_long_description": "People say this stadium is a great place to watch football games and host events like car shows. They highlight the covered seating, wheelchair accessibility, and well-maintained field. They also like the ample parking, including an extra lot past the main entrance.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nsd.org/schools/enrichment-activities/athletics/attending-a-sporting-event",
      "poi_directions_map_url": "https://maps.google.com/?cid=5132767412481085808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pop-keeney-stadium",
      "poi_latitude": "47.76314900000001",
      "poi_longitude": "-122.2112143",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-408-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f30-759f-8568-d103001c97a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f30-759f-8568-d103001c97a4",
        "storage_key": "property/5672714597564416/019d01a0-2f30-759f-8568-d103001c97a4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3WMRuUEOkFQRcNGiX8RAO0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e88ece4a-065a-4325-8501-667a5f9d38d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Bellevue Arts Museum",
      "poi_type": "Entertainment",
      "poi_address": "510 Bellevue Way NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Several large galleries host shows & installations, plus demos, by regional & national artists.",
      "poi_long_description": "Several large galleries host shows & installations, plus demos, by regional & national artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-0500-714b-94dd-d078f17a86ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-0500-714b-94dd-d078f17a86ec",
        "storage_key": "property/5672714597564416/019d01a0-0500-714b-94dd-d078f17a86ec.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bellevuearts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12351560547486155418&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bellevue-arts-museum",
      "poi_latitude": "47.6153759",
      "poi_longitude": "-122.2011901",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-519-0770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f1f-768f-b2cb-37fcd3bdc10e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f1f-768f-b2cb-37fcd3bdc10e",
        "storage_key": "property/5672714597564416/019d01a0-2f1f-768f-b2cb-37fcd3bdc10e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4NgIoZskFQRmkKkZuCOaas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_548f9e35-95e3-4e7a-96ad-dbbdbddd1b98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Marymoor Windmill",
      "poi_type": "Entertainment",
      "poi_address": "Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-07b3-723c-9ce5-47ada534551e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-07b3-723c-9ce5-47ada534551e",
        "storage_key": "property/5672714597564416/019d01a0-07b3-723c-9ce5-47ada534551e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17089669403101244714&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "marymoor-windmill",
      "poi_latitude": "47.6615945",
      "poi_longitude": "-122.1231962",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f1f-768f-b2cb-37fcd3bdc10e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f1f-768f-b2cb-37fcd3bdc10e",
        "storage_key": "property/5672714597564416/019d01a0-2f1f-768f-b2cb-37fcd3bdc10e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJC66t6aBykFQRKi229MazKu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_674a8c87-ece2-4aad-9d28-301f2d1a2ba5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Walter L. Seabloom Field",
      "poi_type": "Entertainment",
      "poi_address": "17272 NE 104th St, Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-08d2-700b-a26d-597bbe530cf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-08d2-700b-a26d-597bbe530cf1",
        "storage_key": "property/5672714597564416/019d01a0-08d2-700b-a26d-597bbe530cf1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://rhs.lwsd.org/athletics/stadium-calendar",
      "poi_directions_map_url": "https://maps.google.com/?cid=14895864739562054015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "walter-l-seabloom-field",
      "poi_latitude": "47.6941606",
      "poi_longitude": "-122.1097894",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-936-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f30-759f-8568-d103001c97a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f30-759f-8568-d103001c97a4",
        "storage_key": "property/5672714597564416/019d01a0-2f30-759f-8568-d103001c97a4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf6eT-S8NkFQRf-HcFw--uM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_12cd5984-ca5d-49ca-b2a4-a254e853069e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12321 120th Pl NE, Kirkland, WA 98034, USA",
      "poi_short_description": "Friendly, health-focused chain with a pool and strength-training equipment.",
      "poi_long_description": "Some gym goers say this gym has a wide variety of equipment, including treadmills, weights, and racketball courts, and they appreciate the friendly staff.\n\nOther reviews mention the gym can be crowded and parking can be difficult.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=694&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4987240807792720913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.70885089999999",
      "poi_longitude": "-122.1797427",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-298-1331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZdPp4ENkFQRETzRVRc9NkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bbdb3f8b-c4a7-43d6-a13a-8eaf4b9d9ba4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "425 FITNESS REDMOND",
      "poi_type": "Health and Wellness",
      "poi_address": "7956 178th Pl NE, Redmond, WA 98052, USA",
      "poi_short_description": "Clean facility, well-equipped for weights and cardio, with a pool and classes.",
      "poi_long_description": "People say this fitness center offers a wide range of equipment, classes, and amenities, including a pool, sauna, and hydro massage chairs, and is clean and spacious.\n\nOther reviews mention the parking can be difficult and the policies can be inflexible.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-0f39-71cb-9b37-d51bf40a7e72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-0f39-71cb-9b37-d51bf40a7e72",
        "storage_key": "property/5672714597564416/019d01a0-0f39-71cb-9b37-d51bf40a7e72.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "http://www.425fitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11066986025667231786&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "425-fitness-redmond",
      "poi_latitude": "47.6749409",
      "poi_longitude": "-122.101864",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-883-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXUe2sdykFQRKoAbqifVlZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_7a759129-8644-45d5-a9c9-8d0a95d0d2fb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Emerald City Gymnastics Academy",
      "poi_type": "Health and Wellness",
      "poi_address": "17965 NE 65th St, Redmond, WA 98052, USA",
      "poi_short_description": "Children's gymnastics center featuring classes, parties, and teams, plus state-of-the-art facilities.",
      "poi_long_description": "People say this gymnastics center offers a variety of classes and programs for children of all ages and skill levels, including competitive teams. They also highlight the coaches are professional, caring, and dedicated, and the facility is clean, well-equipped, and frequently upgraded.\n\nOther reviews mention the schedule can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-126b-7288-9ad1-f8a429b09cff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-126b-7288-9ad1-f8a429b09cff",
        "storage_key": "property/5672714597564416/019d01a0-126b-7288-9ad1-f8a429b09cff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://emeraldcitygymnasticsacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17321808486623697514&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emerald-city-gymnastics-academy",
      "poi_latitude": "47.6624154",
      "poi_longitude": "-122.100985",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-861-8772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c2e-726e-8ea8-0bc6a3fbba48",
        "storage_key": "property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt5iiQJZykFQRalqNMAttY_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_90299b4e-ef4e-466e-82da-c7377eb6d35a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Pacific Reign Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "12728 NE 178th St, Woodinville, WA 98072, USA",
      "poi_short_description": "Training center providing a range of gymnastics programs for all ages and skill levels.",
      "poi_long_description": "People say this gymnastics center offers a variety of classes for different ages and skill levels, including recreational and competitive programs. They highlight the well-organized curriculum, professional staff, and fun, supportive environment. They also like the convenient location, ample parking, and clean, bright facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-14ce-702a-bb4a-a6c0696f054a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-14ce-702a-bb4a-a6c0696f054a",
        "storage_key": "property/5672714597564416/019d01a0-14ce-702a-bb4a-a6c0696f054a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://pacificreign.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=257775700063114341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacific-reign-gymnastics",
      "poi_latitude": "47.75671",
      "poi_longitude": "-122.1689682",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-488-1881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c2e-726e-8ea8-0bc6a3fbba48",
        "storage_key": "property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkV2yoPQPkFQRZVT9KaLNkwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5124f36a-f011-4f38-a3f9-a7f5a78282aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Seattle Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Sand Point Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-1724-706c-b5c4-3b949d0e8a03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-1724-706c-b5c4-3b949d0e8a03",
        "storage_key": "property/5672714597564416/019d01a0-1724-706c-b5c4-3b949d0e8a03.webp",
        "width": 920,
        "height": 612
      },
      "poi_business_url": "https://www.seattlechildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535247879101277020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-childrens-hospital",
      "poi_latitude": "47.6628364",
      "poi_longitude": "-122.281996",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 206-987-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3e-76ef-9c26-dd5370cfc5b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3e-76ef-9c26-dd5370cfc5b3",
        "storage_key": "property/5672714597564416/019d01a0-2f3e-76ef-9c26-dd5370cfc5b3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYx10YIUkFQRXOPoZdRuFaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ed1b35b5-853a-48cf-862b-5f20f260282c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "EvergreenHealth Medical Center Kirkland",
      "poi_type": "Health and Wellness",
      "poi_address": "12040 NE 128th St, Kirkland, WA 98034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-1765-73c9-9649-05324c8e893c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-1765-73c9-9649-05324c8e893c",
        "storage_key": "property/5672714597564416/019d01a0-1765-73c9-9649-05324c8e893c.webp",
        "width": 600,
        "height": 563
      },
      "poi_business_url": "https://www.evergreenhealth.com/?utm_source=EH-MEDCENTER&utm_campaign=Local-Listings&utm_medium=Google-My-Business",
      "poi_directions_map_url": "https://maps.google.com/?cid=14406417902947637237&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "evergreenhealth-medical-center-kirkland",
      "poi_latitude": "47.7156418",
      "poi_longitude": "-122.1795593",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-899-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3e-76ef-9c26-dd5370cfc5b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3e-76ef-9c26-dd5370cfc5b3",
        "storage_key": "property/5672714597564416/019d01a0-2f3e-76ef-9c26-dd5370cfc5b3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-7eSYUNkFQR9ZcFF8Hg7cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_90a986e2-836c-4980-a87c-e5c7f8897e83",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Marymoor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6046 West Lake Sammamish Pkwy NE, Redmond, WA 98052, USA",
      "poi_short_description": "684-acre park featuring a spacious off-leash dog area, climbing wall, soccer fields & concerts.",
      "poi_long_description": "Visitors say this park offers a spacious off-leash dog park, a velodrome, soccer fields, and a concert venue with a variety of events, including Cirque du Soleil. They also highlight the park's extensive trails, ideal for walking, biking, and enjoying the scenery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-194b-747f-9e0f-0397f5749ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-194b-747f-9e0f-0397f5749ccc",
        "storage_key": "property/5672714597564416/019d01a0-194b-747f-9e0f-0397f5749ccc.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.kingcounty.gov/services/parks-recreation/parks/parks-and-natural-lands/popular-parks/marymoor.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=732428507287546141&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "marymoor-park",
      "poi_latitude": "47.6627419",
      "poi_longitude": "-122.1216252",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-477-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-320c-7796-9147-74d24ad587d5",
        "storage_key": "property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fWNvq9ykFQRHWk-yNgbKgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0b7a97e3-329e-4e0b-9bb8-c7da311eec28",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Juanita Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9703 NE Juanita Dr, Kirkland, WA 98034, USA",
      "poi_short_description": "This park features a sandy beach, volleyball & tennis courts, ball fields, fishing & a playground.",
      "poi_long_description": "People say this park offers a beautiful beach, a pier, walking trails, and a playground. They highlight the clean restrooms, well-maintained grounds, and ample parking. They also like the family-friendly atmosphere and opportunities for picnics, paddleboarding, and volleyball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-1bc1-759b-bd10-85920df4ca90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-1bc1-759b-bd10-85920df4ca90",
        "storage_key": "property/5672714597564416/019d01a0-1bc1-759b-bd10-85920df4ca90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kirklandwa.gov/depart/parks/Parks_and_Open_Spaces/Online_Parks_Guide/Parks_Pop-up_Main/Parks_and_Community_Services__Juanita_Beach_Park.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15784180254516446732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "juanita-beach-park",
      "poi_latitude": "47.7046205",
      "poi_longitude": "-122.2147696",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-587-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-320c-7796-9147-74d24ad587d5",
        "storage_key": "property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSZt12cSkFQRDAYwNVCsDNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_103b7be5-e38e-47cc-a328-dab6fd5a4051",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Grass Lawn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7031 148th Ave NE, Redmond, WA 98052, USA",
      "poi_short_description": "Tree-filled public park with tennis & basketball courts, sports fields & an extensive playground.",
      "poi_long_description": "Visitors say this park offers a variety of activities, including tennis courts, soccer fields, basketball courts, a splash pad, and playgrounds with sand pits. They also highlight the ample parking, well-maintained facilities, and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-1eab-746b-89fb-afeffb4cce78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-1eab-746b-89fb-afeffb4cce78",
        "storage_key": "property/5672714597564416/019d01a0-1eab-746b-89fb-afeffb4cce78.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.redmond.gov/facilities/facility/details/grasslawnpark-62",
      "poi_directions_map_url": "https://maps.google.com/?cid=3803125024226082345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grass-lawn-park",
      "poi_latitude": "47.6681769",
      "poi_longitude": "-122.1461102",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-556-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-320c-7796-9147-74d24ad587d5",
        "storage_key": "property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5Tea1RtkFQRKf5kSQ9qxzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_92f79c66-7bed-4a4f-bd33-c3ff740ef123",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Kenmore Air",
      "poi_type": "Transportation & Transit",
      "poi_address": "6321 NE 175th St, Kenmore, WA 98028, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this seaplane base offers scenic flights with smooth takeoffs and landings, and allows passengers to leave their cars for free. They highlight the friendly and knowledgeable staff, and the quick and easy check-in process. They also like the comfortable waiting area and the overall pleasant experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-213c-77b6-8997-d30624f63b1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-213c-77b6-8997-d30624f63b1e",
        "storage_key": "property/5672714597564416/019d01a0-213c-77b6-8997-d30624f63b1e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.kenmoreair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813633346698526503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kenmore-air",
      "poi_latitude": "47.7569221",
      "poi_longitude": "-122.2579096",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 866-435-9524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-323f-73ea-b3a8-801ae789a76a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-323f-73ea-b3a8-801ae789a76a",
        "storage_key": "property/5672714597564416/019d01a0-323f-73ea-b3a8-801ae789a76a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzRmrNsRkFQRJ7-gRXIGVuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ad1dab1d-03c4-494d-b1d5-cd82f9bbf03d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Redmond Technology",
      "poi_type": "Transportation & Transit",
      "poi_address": "Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-23bc-70d9-b53e-5dc87247900c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-23bc-70d9-b53e-5dc87247900c",
        "storage_key": "property/5672714597564416/019d01a0-23bc-70d9-b53e-5dc87247900c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=485771330237953376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "redmond-technology",
      "poi_latitude": "47.64483999999999",
      "poi_longitude": "-122.13363",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHzxcdW5tkFQRYPXmfHPOvQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_b1327a92-d442-43df-a273-c26fec3a49a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Amazon Bingo (SEA94)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "333 108th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-26c3-7518-a045-21eb8ab43084.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-26c3-7518-a045-21eb8ab43084",
        "storage_key": "property/5672714597564416/019d01a0-26c3-7518-a045-21eb8ab43084.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6544047926512698411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-bingo-sea94",
      "poi_latitude": "47.613514",
      "poi_longitude": "-122.1968831",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WrdZYFtkFQRK8Tr1Oog0Vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5b13b1bc-9607-47de-a3a4-d9da5a3c1042",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Amazon Everest (SEA82)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "425 106th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-26ec-708c-8340-8096dd398dfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-26ec-708c-8340-8096dd398dfc",
        "storage_key": "property/5672714597564416/019d01a0-26ec-708c-8340-8096dd398dfc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10796327587513827041&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-everest-sea82",
      "poi_latitude": "47.6141858",
      "poi_longitude": "-122.1992323",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8zr1odskFQR4f6CTL1C1JU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_69d8be6e-b33f-467e-8f10-1f562258c682",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Amazon Grace (SEA104)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "320 108th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2869-77d9-adb0-cfc9b35a6147.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-2869-77d9-adb0-cfc9b35a6147",
        "storage_key": "property/5672714597564416/019d01a0-2869-77d9-adb0-cfc9b35a6147.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7623026455048586503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-grace-sea104",
      "poi_latitude": "47.6133959",
      "poi_longitude": "-122.1958506",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWkBFsdtkFQRB4WTHixuymk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fc2360d4-f044-467c-9e13-5dd8d5eaa342",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Amazon Sonic (SEA112)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "555 108th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4134542030397458732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-sonic-sea112",
      "poi_latitude": "47.6147783",
      "poi_longitude": "-122.1967378",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSyNXwBtkFQRLEnDJhLYYDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_31f32b07-16a0-463b-afe6-fc1507b95e29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Meta - Nojo 1288 - Spring District Block 16",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1288 123rd Ave NE, Bellevue, WA 98005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2875-74a9-98fb-748a7b669a66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-2875-74a9-98fb-748a7b669a66",
        "storage_key": "property/5672714597564416/019d01a0-2875-74a9-98fb-748a7b669a66.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6742557816342478822&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meta---nojo-1288---spring-district-block-16",
      "poi_latitude": "47.6216565",
      "poi_longitude": "-122.1759541",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6aiQSeptkFQR5n-gQJxgkl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d475dad9-6844-40d7-b2b3-230469d00177",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Cafe Veloce",
      "poi_type": "Restaurants",
      "poi_address": "12514 120th Ave NE, Kirkland, WA 98034",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-a422-75af-a0e8-d3e8ee7b4003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-a422-75af-a0e8-d3e8ee7b4003",
        "storage_key": "property/5672714597564416/019d019f-a422-75af-a0e8-d3e8ee7b4003.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/cafe-veloce-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.71138,-122.17865",
      "poi_item_slug": "cafe-veloce-kirkland",
      "poi_latitude": "47.71138",
      "poi_longitude": "-122.17865",
      "poi_miles_from_property": "0.81",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+14258142972",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJR7sG-IMNkFQRvZCmrNTjbew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0ac8acf2-6a64-4cdc-bb3b-400dbfbd2f51",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "The Box & Burgers Eatery",
      "poi_type": "Restaurants",
      "poi_address": "12305 120th Ave NE, Ste C, Kirkland, WA 98034",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-a40d-722f-b954-ca4e53b9fe4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-a40d-722f-b954-ca4e53b9fe4e",
        "storage_key": "property/5672714597564416/019d019f-a40d-722f-b954-ca4e53b9fe4e.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://www.yelp.com/biz/the-box-and-burgers-eatery-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.708903568244,-122.185198925436",
      "poi_item_slug": "the-box-and-burgers-eatery-kirkland",
      "poi_latitude": "47.708903568244",
      "poi_longitude": "-122.185198925436",
      "poi_miles_from_property": "0.75",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+14258210777",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJqX0Ar4ANkFQRsG4A6b-eXfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0fb01172-6839-418d-b295-7f5f5727ccbc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Due' Cucina - Totem Lake",
      "poi_type": "Restaurants",
      "poi_address": "12670 120th Ave NE, Ste 170, Kirkland, WA 98034",
      "poi_short_description": "",
      "poi_long_description": "At Due' Cucina, we’re all about bringing the joy of Italian regional cooking to your table. Think fresh, handmade pasta, scratch-made sauces, and desserts that make you say, “Mamma mia!” Founded by two Italian friends who grew up eating and cooking the real deal, we’re here to serve authentic, high-quality dishes that won’t break the bank. Whether you’re here for a quick lunch, date night, or just need your pasta fix, we’ve got you covered with bold flavors, cozy vibes, and lots of love in every bite. Come hungry, leave happy—just like family!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-a7a1-7344-9f1a-e47b995a42c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-a7a1-7344-9f1a-e47b995a42c7",
        "storage_key": "property/5672714597564416/019d019f-a7a1-7344-9f1a-e47b995a42c7.webp",
        "width": 666,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/due-cucina-totem-lake-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.7133685038329,-122.18035716724108",
      "poi_item_slug": "due-cucina-totem-lake-kirkland-2",
      "poi_latitude": "47.7133685038329",
      "poi_longitude": "-122.1803571672411",
      "poi_miles_from_property": "0.96",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+14257777725",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJzWfj-acNkFQRYToIg4hbqBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dbd2f76d-8266-4b28-b143-df72f2164401",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Lake Washington CrossFit",
      "poi_type": "Gyms",
      "poi_address": "11853 124th Ave NE, Kirkland, WA 98034",
      "poi_short_description": "",
      "poi_long_description": "Kirkland's best spot for Community, CrossFit, Fitness and Fun since 2012!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-aba1-758a-869f-bbeaa039c096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-aba1-758a-869f-bbeaa039c096",
        "storage_key": "property/5672714597564416/019d019f-aba1-758a-869f-bbeaa039c096.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/lake-washington-crossfit-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.706261,-122.178698",
      "poi_item_slug": "lake-washington-crossfit-kirkland",
      "poi_latitude": "47.706261",
      "poi_longitude": "-122.178698",
      "poi_miles_from_property": "0.46",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14256918506",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJPxh0bH8NkFQR0P3b0rb58_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d02b3ef0-7b78-4a09-9491-d1f3baafb9d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Acuo CrossFit",
      "poi_type": "Gyms",
      "poi_address": "8545 152nd Ave NE, Redmond, WA 98052",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-abde-70de-8a71-368389a81201.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-abde-70de-8a71-368389a81201",
        "storage_key": "property/5672714597564416/019d019f-abde-70de-8a71-368389a81201.webp",
        "width": 1000,
        "height": 666
      },
      "poi_business_url": "https://www.yelp.com/biz/acuo-crossfit-redmond-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.680156,-122.138442",
      "poi_item_slug": "acuo-crossfit-redmond-2",
      "poi_latitude": "47.680156",
      "poi_longitude": "-122.138442",
      "poi_miles_from_property": "2.23",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+14253071800",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJJdRZgVMNkFQRmldbI95lLxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bc82d995-b17e-4286-9a45-cb1bcb864ea9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Eastside Gym",
      "poi_type": "Gyms",
      "poi_address": "15040 NE 95th St, Redmond, WA 98052",
      "poi_short_description": "",
      "poi_long_description": "Eastside Gym of Redmond WA, is dedicated to body conditioning and weight training in an environment that promotes positive attitudes and personal development. Eastside is an independent gym, not a franchise, and is designed for true personal gains. Personal training is available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-ac7a-74f0-9871-2fa251b244e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-ac7a-74f0-9871-2fa251b244e1",
        "storage_key": "property/5672714597564416/019d019f-ac7a-74f0-9871-2fa251b244e1.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/eastside-gym-redmond?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.68619,-122.139846",
      "poi_item_slug": "eastside-gym-redmond",
      "poi_latitude": "47.68619",
      "poi_longitude": "-122.139846",
      "poi_miles_from_property": "1.94",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+14258827764",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJy4TmyVoNkFQRQZ7CcujNQ2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_60494b34-8a59-41fc-b8a2-692690ef2308",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Kutting Edge Fitness",
      "poi_type": "Gyms",
      "poi_address": "14766 NE 95th St, Redmond, WA 98052",
      "poi_short_description": "",
      "poi_long_description": "Experience the fun at Kutting Edge Fitness! You will burn fat, build strength, gain confidence, look and feel better! We will be the best, brightest, and most challenging part of your day!! Our coaches are experts in exercise physiology and functional training! No one else in Washington even comes close with helping you reach your goals! Whether that goal is weight loss, building lean muscle, or adding distance and consistency to your golf swing, we will make it happen. Our coaches are very qualified and always seeking to improve their skills with additional training. Each KE Coach is certified to provide you with outstanding coaching in a small group environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-af4a-72de-93ca-11c41ccf0e38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-af4a-72de-93ca-11c41ccf0e38",
        "storage_key": "property/5672714597564416/019d019f-af4a-72de-93ca-11c41ccf0e38.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.yelp.com/biz/kutting-edge-fitness-redmond?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6862851,-122.1437217",
      "poi_item_slug": "kutting-edge-fitness-redmond",
      "poi_latitude": "47.6862851",
      "poi_longitude": "-122.1437217",
      "poi_miles_from_property": "1.78",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+14253071706",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJx_Otpr4SkFQRBMbmBk4sXyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eec025cd-7fe7-4bfe-8ca0-32c5d7f5f624",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Kirkland Community Fitness",
      "poi_type": "Gyms",
      "poi_address": "1015 7th Ave, Ste 140, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-afd9-70af-a595-4a699c080f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-afd9-70af-a595-4a699c080f1e",
        "storage_key": "property/5672714597564416/019d019f-afd9-70af-a595-4a699c080f1e.webp",
        "width": 1000,
        "height": 666
      },
      "poi_business_url": "https://www.yelp.com/biz/kirkland-community-fitness-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.68041,-122.19098",
      "poi_item_slug": "kirkland-community-fitness-kirkland",
      "poi_latitude": "47.68041",
      "poi_longitude": "-122.19098",
      "poi_miles_from_property": "1.52",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+12068981810",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJCW8DJ8ASkFQR6vo3AFdSAQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_06075026-725d-44a2-8cd4-05e7a4353936",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Orion Montessori",
      "poi_type": "Elementary Schools",
      "poi_address": "11120 127th Ave NE, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-b122-7439-b2b3-ca74f52eb32e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-b122-7439-b2b3-ca74f52eb32e",
        "storage_key": "property/5672714597564416/019d019f-b122-7439-b2b3-ca74f52eb32e.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/orion-montessori-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.70054,-122.17167",
      "poi_item_slug": "orion-montessori-kirkland-2",
      "poi_latitude": "47.70054",
      "poi_longitude": "-122.17167",
      "poi_miles_from_property": "0.23",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+14254993313",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJezZfrn0NkFQRu7CiolQQC9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a973de46-d2d5-4ca7-bd27-f6911125f57b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Northlake Preschool",
      "poi_type": "Elementary Schools",
      "poi_address": "12931 NE 126th Pl, Bldg B1, Kirkland, WA 98034",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/northlake-preschool-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.7136399,-122.1676539",
      "poi_item_slug": "northlake-preschool-kirkland-2",
      "poi_latitude": "47.7136399",
      "poi_longitude": "-122.1676539",
      "poi_miles_from_property": "1.04",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+14258894444",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJWzTR8dwSkFQRX7TCYa1KuTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8d62c2e7-51e8-4773-88c4-d6774e6728ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "The Attic Learning Community",
      "poi_type": "High Schools",
      "poi_address": "24023 51st Ave SE, Woodinville, WA 98072",
      "poi_short_description": "",
      "poi_long_description": "The Attic is a unique and innovative pre-K through 12th progressive learning community located in Woodinville, WA. Our mission is to nurture in all children a sense of self and a passion for learning, community, and childhood. At The Attic, our greatest hope is that children will be authentic—that they will truly know who they are, and that they will be empowered to bring their unique gifts into the world. We support them in fulfilling this hope through our unique paradigm that sees education as founded on trusting each individual child’s long-term growth and development. With this vision at the heart of our work, we nurture autonomy and a sense of self as we foster a passion for learning, community, childhood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-b4f8-7769-a459-bc596ceefbbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-b4f8-7769-a459-bc596ceefbbf",
        "storage_key": "property/5672714597564416/019d019f-b4f8-7769-a459-bc596ceefbbf.webp",
        "width": 1000,
        "height": 753
      },
      "poi_business_url": "https://www.yelp.com/biz/the-attic-learning-community-woodinville-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.77958470240294,-122.16379017055222",
      "poi_item_slug": "the-attic-learning-community-woodinville-2",
      "poi_latitude": "47.77958470240294",
      "poi_longitude": "-122.1637901705522",
      "poi_miles_from_property": "5.54",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+14254240800",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJWz2e5pUOkFQR2AUqHdtcfvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0897cbc4-3655-4853-9027-71f61828c3bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Lake Washington High School",
      "poi_type": "High Schools",
      "poi_address": "12033 NE 80th St, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-b537-70ff-be4b-13617c38bf42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-b537-70ff-be4b-13617c38bf42",
        "storage_key": "property/5672714597564416/019d019f-b537-70ff-be4b-13617c38bf42.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/lake-washington-high-school-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6752667,-122.1800647",
      "poi_item_slug": "lake-washington-high-school-kirkland",
      "poi_latitude": "47.6752667",
      "poi_longitude": "-122.1800647",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+14259361700",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJSTYViLgSkFQRmixJpC2APYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_47f26dcb-b91f-4b0b-a5bc-13c4dca8a274",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Zulu's Board Game Cafe",
      "poi_type": "Shopping",
      "poi_address": "10234 Main St, Bothell, WA 98011",
      "poi_short_description": "",
      "poi_long_description": "We are all about card games, board games, table top games, and pen and paper games. We also have a full kitchen, drinks, beer and wine. We have indoor seating for large groups, tournaments and smaller tabletops for 2-4. There is space available in the basement to rent for private events / games and a covered deck area and uncovered patio. Come in and check us out - we are family friendly!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-bd22-719e-b2e4-e5184ab65452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-bd22-719e-b2e4-e5184ab65452",
        "storage_key": "property/5672714597564416/019d019f-bd22-719e-b2e4-e5184ab65452.webp",
        "width": 1000,
        "height": 711
      },
      "poi_business_url": "https://www.yelp.com/biz/zulus-board-game-cafe-bothell?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.7604567377138,-122.202434033818",
      "poi_item_slug": "zulus-board-game-cafe-bothell",
      "poi_latitude": "47.7604567377138",
      "poi_longitude": "-122.202434033818",
      "poi_miles_from_property": "4.36",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+14258188122",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ5xqmaWkOkFQRPzsLd5Jie4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fb1d3afd-bfa9-484f-9a67-a4b98f30058e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Fena Flowers",
      "poi_type": "Shopping",
      "poi_address": "12815 NE 124th St, Ste K, Kirkland, WA 98034",
      "poi_short_description": "",
      "poi_long_description": "Fena Flowers, Inc. proudly serves Kirkland and the surrounding areas. We're family owned and operated, and committed to offering only the finest floral arrangements and gifts, backed by service that is friendly and prompt. We always go the extra mile to make your floral gift perfect. Let Fena Flowers, Inc. be your first choice for flowers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-bfae-700e-805b-4826ad68ea88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-bfae-700e-805b-4826ad68ea88",
        "storage_key": "property/5672714597564416/019d019f-bfae-700e-805b-4826ad68ea88.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/fena-flowers-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.7104911804199,-122.16886138916",
      "poi_item_slug": "fena-flowers-kirkland-2",
      "poi_latitude": "47.7104911804199",
      "poi_longitude": "-122.16886138916",
      "poi_miles_from_property": "0.82",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+14258258181",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJY4EaN50NkFQRVtOfYF732yE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_156a1cd2-25d0-4b69-a6cd-c815968e52ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "DeLille Cellars",
      "poi_type": "Entertainment",
      "poi_address": "14300 NE 145th St, Ste 101, Woodinville, WA 98072",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-c0c0-73d0-a75d-e0d1021aa789.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-c0c0-73d0-a75d-e0d1021aa789",
        "storage_key": "property/5672714597564416/019d019f-c0c0-73d0-a75d-e0d1021aa789.webp",
        "width": 660,
        "height": 432
      },
      "poi_business_url": "https://www.yelp.com/biz/delille-cellars-woodinville?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.734785,-122.148939",
      "poi_item_slug": "delille-cellars-woodinville",
      "poi_latitude": "47.734785",
      "poi_longitude": "-122.148939",
      "poi_miles_from_property": "2.73",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+14254890544",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_df506cd0-289a-46d0-beb9-51b6a6247731",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Maryhill Tasting Room & Bistro - Woodinville",
      "poi_type": "Entertainment",
      "poi_address": "14810 NE 145th St, Ste A, Woodinville, WA 98072",
      "poi_short_description": "",
      "poi_long_description": "Maryhill has opened its third satellite tasting room in Woodinville, Washington. Located just 30 minutes northeast of Seattle, Woodinville Wine Country is home to more than 100 wineries and tasting rooms representing every appellation in Washington. Maryhill Winery will occupy nearly 10,000 square feet of Woodinville's historic Hollywood Schoolhouse, a beloved landmark since its construction by the Derby School District in 1912. The Hollywood Schoolhouse has been restored to its turn-of-the century style, down to the grand ballroom's hardwood floors, antique bar and brick fireplace. Maryhill occupies the grand ballroom and upper floor, along with a full commercial kitchen. Maryhill offers special events and rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-c38f-7199-a5c3-4e28363c57cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-c38f-7199-a5c3-4e28363c57cf",
        "storage_key": "property/5672714597564416/019d019f-c38f-7199-a5c3-4e28363c57cf.webp",
        "width": 1000,
        "height": 665
      },
      "poi_business_url": "https://www.yelp.com/biz/maryhill-tasting-room-and-bistro-woodinville-woodinville?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.732993,-122.141615",
      "poi_item_slug": "maryhill-tasting-room-and-bistro-woodinville-woodinville",
      "poi_latitude": "47.732993",
      "poi_longitude": "-122.141615",
      "poi_miles_from_property": "2.81",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+14254817925",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ3ZSyTrMNkFQR6FEGtSK7X8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_48f88cc9-4e28-44dc-b130-7a5ca1c60229",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "12026 NE 124th St, Kirkland, WA 98034, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves tasty chicken sandwiches and nuggets. They highlight the clean facilities and decent value. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019dbbe3-1a1e-7722-b842-5ed22158da28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe3-1a1e-7722-b842-5ed22158da28",
        "storage_key": "property/5672714597564416/019dbbe3-1a1e-7722-b842-5ed22158da28.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/totem-lake?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17100142271408924863&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.7096168",
      "poi_longitude": "-122.1792938",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-803-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c0f-71fc-b179-8494ae2a5236",
        "storage_key": "property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjyZqaYENkFQRv2j4n8voT-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3ea5362f-7fd9-47dd-bba9-75b8593bd956",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Rimini Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3 Lake St, Kirkland, WA 98033, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Italian restaurant serves delicious, fresh pasta and flavorful sauces, with generous portions. They highlight the cozy, romantic atmosphere with live music, and the attentive, friendly service. They also like the warm, welcoming vibe and the staff's personalized touches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019dbbe3-1bd6-72fb-8e72-6ad8ca4372b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe3-1bd6-72fb-8e72-6ad8ca4372b2",
        "storage_key": "property/5672714597564416/019dbbe3-1bd6-72fb-8e72-6ad8ca4372b2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.riminirestaurant.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14264055917082256875&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rimini-restaurant",
      "poi_latitude": "47.675688",
      "poi_longitude": "-122.2068061",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-242-0070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c0f-71fc-b179-8494ae2a5236",
        "storage_key": "property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFbYQ_JgTkFQR6yX_SUgb9MU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_cc456567-c432-4815-8fc5-a101d02399ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Kirkland Middle School",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8606b65d-bf58-4158-b7c3-b5b3d50569f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "DERU Market",
      "poi_type": "Restaurants",
      "poi_address": "723 9th Ave, Ste D, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-a400-702f-9907-fadb3fc60ac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019f-a400-702f-9907-fadb3fc60ac1",
        "storage_key": "property/5672714597564416/019d019f-a400-702f-9907-fadb3fc60ac1.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/deru-market-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6820752,-122.1941814",
      "poi_item_slug": "deru-market-kirkland",
      "poi_latitude": "47.6820752",
      "poi_longitude": "-122.1941814",
      "poi_miles_from_property": "1.48",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+14252980268",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ9SkOAusSkFQRH1ho03tioGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a786e6b-3ee4-41b7-9a8d-14a5ec1d28f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12501 120th Ave NE, Kirkland, WA 98034, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of high-quality produce, gourmet supplies, and ready-to-eat options, including a hot bar, salad bar, and pizza. They also highlight the clean and well-stocked store, the welcoming atmosphere, and the convenient Amazon return kiosk.\n\nOther reviews mention the parking lot can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-d9a9-748e-8bfd-5bcde259d6cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-d9a9-748e-8bfd-5bcde259d6cd",
        "storage_key": "property/5672714597564416/019e4776-d9a9-748e-8bfd-5bcde259d6cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/kirkland?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4843404829819413838&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.711541",
      "poi_longitude": "-122.1800667",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-979-3301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c00-7028-8d95-46ccc339d26c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c00-7028-8d95-46ccc339d26c",
        "storage_key": "property/5672714597564416/019d01a0-2c00-7028-8d95-46ccc339d26c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRx4YnAQNkFQRTiXMAAg7N0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c192f38f-4679-426e-8cc6-3013ce2c8fbf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "18333 120th Ave NE, Bothell, WA 98011, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has a wide selection of tools, lumber, and supplies for any project, and they appreciate the helpful and friendly staff. They also highlight the well-organized and clean environment, making it easy to find the right products.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-d7ff-72de-8262-80d76783ecb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-d7ff-72de-8262-80d76783ecb5",
        "storage_key": "property/5672714597564416/019e4776-d7ff-72de-8262-80d76783ecb5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Bothell/WA/Bothell/98011/4712?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11676615433004388263&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "47.7600012",
      "poi_longitude": "-122.1778955",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-806-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c00-7028-8d95-49be54e2f600.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c00-7028-8d95-49be54e2f600",
        "storage_key": "property/5672714597564416/019d01a0-2c00-7028-8d95-49be54e2f600.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHU85OX0OkFQRpw8S996rC6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_d976a48f-d6b4-4b56-85e1-87d492ba55a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "24122 Bothell Everett Hwy, Bothell, WA 98021, USA",
      "poi_short_description": "",
      "poi_long_description": "Reviewers praise this gym for its wide variety of equipment, friendly staff, and a welcoming, judgment-free environment.\n\nOther reviews mention canceling memberships can be difficult and the facility can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-0ac4-750c-9288-db324597ba2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-0ac4-750c-9288-db324597ba2f",
        "storage_key": "property/5672714597564416/019d01a0-0ac4-750c-9288-db324597ba2f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/bothell-north-wa?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17509364216771361817&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.778071",
      "poi_longitude": "-122.2200713",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-384-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSmnAUEPkFQRGbyXj_zB_fI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3cfea27b-fd6e-46b8-a44e-15d9ca36192e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "18006 120th Ave NE, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "Reviewers consistently praise this gym for its great variety of well-maintained equipment and its friendly, helpful staff who cultivate a welcoming atmosphere.\n\nOther reviews mention the facility can be neglected and not truly 24 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-da66-740f-86cf-a9a98d66aa3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-da66-740f-86cf-a9a98d66aa3f",
        "storage_key": "property/5672714597564416/019e4776-da66-740f-86cf-a9a98d66aa3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/bothell-wa/bothell-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=9734597478713896484&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.7587853",
      "poi_longitude": "-122.1730193",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-492-1911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwODg30OkFQRJK4nrtQ8GIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5f863eb4-e308-4f65-bb1b-d881c74a1db9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Dilli-6",
      "poi_type": "Restaurants",
      "poi_address": "11701 124th Ave NE, Kirkland, WA 98034, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners say this restaurant offers authentic North Indian cuisine with flavorful dishes like chole bhature and a wide variety of chaat. They also highlight the excellent service and welcoming ambiance.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-df6d-7618-b4d8-ec5c6a4dc26f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-df6d-7618-b4d8-ec5c6a4dc26f",
        "storage_key": "property/5672714597564416/019e4776-df6d-7618-b4d8-ec5c6a4dc26f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dilli-6.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9469075895651992785&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dilli-6",
      "poi_latitude": "47.7049502",
      "poi_longitude": "-122.1763474",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-292-2497",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c0f-71fc-b179-8494ae2a5236",
        "storage_key": "property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTe44ixMNkFQR0QSNl1vqaIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_56d2d03d-c839-44e8-916d-ad7a5d90fbe9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Kabab House",
      "poi_type": "Restaurants",
      "poi_address": "12041 124th Ave NE, Kirkland, WA 98034, USA",
      "poi_short_description": "Tiny establishment popular with locals for its array of traditional Indian & Pakistani comfort eats.",
      "poi_long_description": "Reviewers consistently praise this restaurant for its flavorful biryani, tender kebabs, and delicious white chicken karahi, alongside the friendly, welcoming staff and reasonable prices. These aspects contribute to a highly positive dining experience.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-dfe1-7338-a7dd-2dd4b5f0a597.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-dfe1-7338-a7dd-2dd4b5f0a597",
        "storage_key": "property/5672714597564416/019e4776-dfe1-7338-a7dd-2dd4b5f0a597.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kababhousepk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9597486721707528791&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kabab-house",
      "poi_latitude": "47.7061278",
      "poi_longitude": "-122.177104",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-559-3185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c0f-71fc-b179-8494ae2a5236",
        "storage_key": "property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJy9hxbQSkFQRV9Ln31IfMYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pakistani_restaurant"
    },
    {
      "id": "custom_56061ad6-b9de-41af-ae4c-35398e1dc537",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "The Village at Totem Lake",
      "poi_type": "Shopping & Retail",
      "poi_address": "11901 NE Village Plaza, Kirkland, WA 98034, USA",
      "poi_short_description": "Enduring unpretentious shopping center with a variety of retail & dining locations.",
      "poi_long_description": "Visitors say this outdoor mall offers a wide variety of shops and restaurants, along with heated outdoor seating areas and a clean, upscale public space. They also highlight the family-friendly atmosphere and the convenience of having many amenities in one walkable area.\n\nSome reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-daba-76b3-8117-02cdef5b2544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-daba-76b3-8117-02cdef5b2544",
        "storage_key": "property/5672714597564416/019e4776-daba-76b3-8117-02cdef5b2544.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.thevillageattotemlake.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13656443171292538273&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-village-at-totem-lake",
      "poi_latitude": "47.7126199",
      "poi_longitude": "-122.1800502",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-820-9268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c00-7028-8d95-49be54e2f600.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c00-7028-8d95-49be54e2f600",
        "storage_key": "property/5672714597564416/019d01a0-2c00-7028-8d95-49be54e2f600.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoyttBoQNkFQRoWUzmLVuhb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a2843a4f-fd83-4071-b8bb-047846ba5ed0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "12221 120th Ave NE, Kirkland, WA 98034, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, groceries, and other products, including alcohol, pharmacy items, clothing, shoes, toys, and home furnishings. They also highlight the clean and well-stocked shelves, convenient parking, and good deals.\n\nOther reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-d73f-74cc-9c5e-8775d859b736.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-d73f-74cc-9c5e-8775d859b736",
        "storage_key": "property/5672714597564416/019e4776-d73f-74cc-9c5e-8775d859b736.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/wa/kirkland/fred-meyer-kirkland/701/00391?cid=loc_70100391_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1642218835222015052&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "47.7078604",
      "poi_longitude": "-122.184222",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-820-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c00-7028-8d95-46ccc339d26c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c00-7028-8d95-46ccc339d26c",
        "storage_key": "property/5672714597564416/019d01a0-2c00-7028-8d95-46ccc339d26c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgevtloANkFQRTCzdbFRVyhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ee0fb223-3cbe-4777-9f99-ba98b6a6a6a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11325 NE 124th St, Kirkland, WA 98034, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners appreciate this restaurant's delicious and hearty Italian-American food, which includes many vegetarian options. They also highlight the warm, welcoming atmosphere, reasonable prices, and attentive staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-da0c-7128-afbf-3672a0eeeccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-da0c-7128-afbf-3672a0eeeccc",
        "storage_key": "property/5672714597564416/019e4776-da0c-7128-afbf-3672a0eeeccc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.olivegarden.com/locations/wa/kirkland/kirkland-totem-lake/1318?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:kirkland-wa-1318_pl:locurl_rd:1241",
      "poi_directions_map_url": "https://maps.google.com/?cid=18290513252811985291&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "47.710892",
      "poi_longitude": "-122.189572",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-820-7740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c0f-71fc-b179-8494ae2a5236",
        "storage_key": "property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNUY1fXgSkFQRi9FuaeX01P0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_310f5aa5-8de1-4ada-a35c-0ef5eb8c6c54",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Pump It Up Kirkland Kids Birthdays and More",
      "poi_type": "Entertainment",
      "poi_address": "11605 NE 116th St, Kirkland, WA 98034, USA",
      "poi_short_description": "Indoor party venue featuring inflatable attractions along with dedicated spaces for food and cake.",
      "poi_long_description": "People say this children's amusement center is a great place to host birthday parties, with fun activities for kids of all ages, especially those between 3 and 6 years old. They also highlight the helpful staff who make party planning smooth and stress-free, and the clean and well-maintained facilities.\n\nSome reviews mention the pricing for certain activities can be inconvenient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-dea4-7693-8dbe-988d0591487c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-dea4-7693-8dbe-988d0591487c",
        "storage_key": "property/5672714597564416/019e4776-dea4-7693-8dbe-988d0591487c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.pumpitupparty.com/kirkland-wa?utm_source=gmb&utm_medium=organic&utm_campaign=gmb_organic_traffic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2836880692438446142&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pump-it-up-kirkland-kids-birthdays-and-more",
      "poi_latitude": "47.7036385",
      "poi_longitude": "-122.1854095",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-820-2297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjT-OKH4SkFQRPjD1lvWfXic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_7c81799f-7f4d-4bca-a5d2-4ec15c3c0085",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Sandbox VR",
      "poi_type": "Entertainment",
      "poi_address": "12675 120th Ave NE Suite 195, Kirkland, WA 98034, USA",
      "poi_short_description": "Cutting-edge VR gaming center with a variety of action-movie-themed titles such as zombie mansions.",
      "poi_long_description": "People say this amusement center offers a fun and immersive Squid Game VR experience, with helpful and friendly staff, especially Shenn, who consistently receives praise for his exceptional service. They also highlight the well-maintained equipment and the realistic and engaging gameplay.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4776-dea5-70e0-bc57-e85773f85812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4776-dea5-70e0-bc57-e85773f85812",
        "storage_key": "property/5672714597564416/019e4776-dea5-70e0-bc57-e85773f85812.webp",
        "width": 1280,
        "height": 837
      },
      "poi_business_url": "https://sandboxvr.com/seattle",
      "poi_directions_map_url": "https://maps.google.com/?cid=3956957623204432235&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sandbox-vr",
      "poi_latitude": "47.7134856",
      "poi_longitude": "-122.1809228",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-403-7557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2f3b-7798-9973-e3e677add543",
        "storage_key": "property/5672714597564416/019d01a0-2f3b-7798-9973-e3e677add543.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4V9t25ANkFQRa8lfUv7v6TY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_437c7e53-71c9-468b-8432-978f1112228c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "12520 Totem Lake Blvd NE Ste 116, Kirkland, WA 98034, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of snacks, frozen meals, and pantry staples, with many praising the selection of healthy and affordable options. They also highlight the friendly and helpful staff, and the clean and well-stocked store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4784-a417-762d-b903-9b953c9f6118.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4784-a417-762d-b903-9b953c9f6118",
        "storage_key": "property/5672714597564416/019e4784-a417-762d-b903-9b953c9f6118.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/kirkland/132/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15173403197318358355&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.7118681",
      "poi_longitude": "-122.1807214",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-814-9181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c00-7028-8d95-46ccc339d26c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c00-7028-8d95-46ccc339d26c",
        "storage_key": "property/5672714597564416/019d01a0-2c00-7028-8d95-46ccc339d26c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-bkSBoQNkFQRU-Xv2dDBktI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4e73b42f-c8b6-4b48-a321-191d2b321714",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Sparrow",
      "poi_type": "Restaurants",
      "poi_address": "9736 NE 120th Pl, Kirkland, WA 98034, USA",
      "poi_short_description": "Neighborhood restaurant with a seasonal menu of American fare plus a bar, patio, and live music.",
      "poi_long_description": "Diners say this American restaurant serves up delicious halibut, spicy chicken sandwiches, and banana bread pudding. They also highlight the elegant and cozy atmosphere, especially the outdoor patio, and the attentive and friendly service.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4784-a996-72bd-b574-d0f501dd7ebb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4784-a996-72bd-b574-d0f501dd7ebb",
        "storage_key": "property/5672714597564416/019e4784-a996-72bd-b574-d0f501dd7ebb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sparrowkirkland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17184854574411964657&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sparrow",
      "poi_latitude": "47.70818930000001",
      "poi_longitude": "-122.211296",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-686-8231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c0f-71fc-b179-8494ae2a5236",
        "storage_key": "property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2iCHs0TkFQR8WCSqC_efO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1595c1b1-ae0d-4a61-8cf1-1e93b8409b1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Kathakali, An Indian Eatery",
      "poi_type": "Restaurants",
      "poi_address": "11451 98th Ave NE, Kirkland, WA 98033, USA",
      "poi_short_description": "Intimate restaurant with traditional decor specializing in classic & modern South Indian cooking.",
      "poi_long_description": "People say this Indian restaurant serves delicious Kerala cuisine, including Malabar Parotta, appam, and various curries. They also highlight the authentic flavors, beautiful presentation, and warm, attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4784-a46d-773a-8406-1602c235cfb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4784-a46d-773a-8406-1602c235cfb9",
        "storage_key": "property/5672714597564416/019e4784-a46d-773a-8406-1602c235cfb9.webp",
        "width": 1280,
        "height": 696
      },
      "poi_business_url": "https://www.kathakali-juanita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2384798711614657575&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kathakali-an-indian-eatery",
      "poi_latitude": "47.7036038",
      "poi_longitude": "-122.2106818",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-821-8188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c0f-71fc-b179-8494ae2a5236",
        "storage_key": "property/5672714597564416/019d01a0-2c0f-71fc-b179-8494ae2a5236.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVc7-4mYSkFQRJ9SZAsuBGCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_099df0b0-e661-4b8a-a236-b145636fb6d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Juanita Bay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2201 Market St, Kirkland, WA 98033, USA",
      "poi_short_description": "This 110-acre urban wildlife habitat is home to songbirds, waterfowl & beavers plus native foliage.",
      "poi_long_description": "People say this park is excellent for birdwatching and spotting diverse wildlife like eagles, beavers, and turtles, with well-maintained walking trails and boardwalks. Visitors highlight the peaceful and serene atmosphere, making it ideal for relaxing strolls and photography. They also appreciate the convenient parking and accessible, clean restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4784-a992-7475-a224-d9e804ea7e80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4784-a992-7475-a224-d9e804ea7e80",
        "storage_key": "property/5672714597564416/019e4784-a992-7475-a224-d9e804ea7e80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kirklandwa.gov/Government/Departments/Parks-and-Community-Services/Online-Parks-Guide/Juanita-Bay-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1585935035830828993&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "juanita-bay-park",
      "poi_latitude": "47.6986138",
      "poi_longitude": "-122.2110985",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-587-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-320c-7796-9147-74d24ad587d5",
        "storage_key": "property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY_jvLl4SkFQRwf-KL4NfAhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_33f4fc32-c15d-4144-884e-574304f7cbab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Forbes Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11615 NE 106th Ln, Kirkland, WA 98033, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12856340736085629417&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "forbes-creek-park",
      "poi_latitude": "47.6943496",
      "poi_longitude": "-122.1858424",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-320c-7796-9147-74d24ad587d5",
        "storage_key": "property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAZ4USkFQR6ZnEncjlarI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_806719d7-0e8d-4b6d-b1e8-e23cd8c0ec2a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Mark Twain Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10625 132nd Ave NE, Kirkland, WA 98033, USA",
      "poi_short_description": "Neighborhood park with a grass field, a basketball court and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4784-a976-70bf-9090-9eab3fcddadb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4784-a976-70bf-9090-9eab3fcddadb",
        "storage_key": "property/5672714597564416/019e4784-a976-70bf-9090-9eab3fcddadb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kirklandwa.gov/Government/Departments/Parks-and-Community-Services/Online-Parks-Guide/Mark-Twain-Park?BestBetMatch=mark%20twain|ab1c70ec-38e6-40e3-ba22-bf28ebfae84b|3c005e77-8f04-4719-adc1-a980035cb01f|en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=8277003038974680611&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mark-twain-park",
      "poi_latitude": "47.6956996",
      "poi_longitude": "-122.1662139",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-409-3832",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-320c-7796-9147-74d24ad587d5",
        "storage_key": "property/5672714597564416/019d01a0-320c-7796-9147-74d24ad587d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7VIfV2INkFQRIx7qFmnS3XI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_42bbfa90-aeb4-47ca-9d44-e337bedd2a63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "Evergreen Academy Montessori",
      "poi_type": "Education",
      "poi_address": "12345 120th Ave NE, Kirkland, WA 98034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4784-a3cc-706b-99c4-5cd1113aab97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4784-a3cc-706b-99c4-5cd1113aab97",
        "storage_key": "property/5672714597564416/019e4784-a3cc-706b-99c4-5cd1113aab97.webp",
        "width": 764,
        "height": 1024
      },
      "poi_business_url": "https://www.evergreenacademy.com/preschools/wa/seattle/kirkland/?utm_medium=directory&utm_source=gmb&utm_campaign=profile&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2708342738319920021&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "evergreen-academy-montessori",
      "poi_latitude": "47.7103926",
      "poi_longitude": "-122.1870114",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-800-6315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c2e-726e-8ea8-0bc6a3fbba48",
        "storage_key": "property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHyw9aocNkFQRlUuR_173lSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_37e1a6d5-4554-49c3-a596-c7c0fe2f54f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "poi_name": "DigiPen Institute of Technology",
      "poi_type": "Education",
      "poi_address": "9931 Willows Rd NE, Redmond, WA 98052, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019e4784-a4c6-7081-9b5a-b0d34c5c910f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4784-a4c6-7081-9b5a-b0d34c5c910f",
        "storage_key": "property/5672714597564416/019e4784-a4c6-7081-9b5a-b0d34c5c910f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.digipen.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3359851474942275442&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "digipen-institute-of-technology",
      "poi_latitude": "47.6888173",
      "poi_longitude": "-122.150317",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 866-478-5236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a0-2c2e-726e-8ea8-0bc6a3fbba48",
        "storage_key": "property/5672714597564416/019d01a0-2c2e-726e-8ea8-0bc6a3fbba48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE_uiGFwNkFQRcq8Bfh2XoC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3b82ae690399c5af5b61fd8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b19d22e103fa2b7406ee203a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_54032018c911177ab67c6114",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_de598b294be2d1ccfcdcac54",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2b87b50b83d2ebb217edf89d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_f93e838333156c316f95466f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "rating": "5",
      "name": "Gayoung Lee",
      "text": "I’ve lived here for less than a year, but the experience has been amazing. The leasing office staff is always so kind—especially Lizzie! She has been incredibly helpful with everything, from the smallest questions to more significant matters. I also love how the team organizes monthly events for the residents. I wasn't expecting much, but I actually won the Christmas raffle this year! It made my holiday so much more special. Thank you for everything!",
      "date": "2025-12-24",
      "title": "false"
    },
    {
      "id": "ec_9e2a3a97e8681aad56dc6b59",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "rating": "5",
      "name": "Dinh Chi",
      "text": "I had a great experience visiting Aspen Creek Apartments. The community is clean, well maintained, and has a calm, welcoming atmosphere. The grounds look great, and everything felt organized and cared for.\n\nI especially want to mention Devyn, who was friendly, professional, and very helpful during the visit. Devyn answered questions clearly and made the experience pleasant and stress-free. Overall, Aspen Creek made a great impression, and it seems like a wonderful place to live.",
      "date": "2025-12-29",
      "title": "false"
    },
    {
      "id": "ec_b8d53170de5e8a71cfaafdf4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "rating": "5",
      "name": "AR",
      "text": "I've been living at Aspen Creek for about 9 years and I love it. Staff at Leasing office have always been dedicated to provide you a pleasant stay at Aspen. Liz is awesome, seems to handle pressure well, always there for you. Repairs are well taken care. Apartments are spacious, great place for kids or pets. I'm not planning to move out anytime soon :)",
      "date": "2026-01-07",
      "title": "false"
    },
    {
      "id": "ec_34b68972806ff60a8d08800a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "rating": "5",
      "name": "Monique Marina",
      "text": "I almost gave up on looking for a place to call home. Prices are outrageous, or staff at apartment complexes had no idea what they were doing. That was until I came across Devyn and Lizzie at Aspen Creek. Wow, what a breath of fresh air they were. They were knowledgeable and took time to help me. I am so grateful for the experience I had with them and I loved the apartment complexe and home they showed me. My lease is up at the end of Jan. 2026 and I’m hoping to rent from this beautiful place. To call it home would be amazing for me and it checks all my boxes on my list. Not to mention the wonderful help and complete courteous customer service I received from Devyn and Lizzie. If it wasn’t the apartments itself that sold me, it was definitely Devyn and Lizzie. I’m so excited to be a part of their community in the near future and can’t wait to have them as the staff I get to work with and rent from. Thank you from the bottom of my heart!  I look forward to many cozy nights and great memories made here at Aspen creek. I highly recommend. Ask for Devyn, or Lizzie. You won’t be disappointed!",
      "date": "2025-12-10",
      "title": "false"
    },
    {
      "id": "ec_40de3e58269ea9a3615fa0ed",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "rating": "5",
      "name": "Ezra Halasz",
      "text": "My partner and I we're helped out by one of your employees, Devyn the other day. She was patient, kind and knowledgeable and allowed us to take our time veiwing the unit. It did not end up being what we were looking for but our experience here was the best. We both sincerely appreciate Devyn and wish that everyone we work with to find our home could be as delightful as she was.",
      "date": "2025-12-27",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_558d44f3-bfe8-4c07-93d5-69530da04b11",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Aspen Creek Palomino v2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://vimeo.com/429296677?fl=pl&fe=cm"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-f6e0-73c8-a6cb-e17eb9ed0726",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aspen-creek",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416"
    },
    {
      "lead_collector_id": "0198aa46-f742-76ce-b8b7-b7f67a07076e",
      "lead_source": "FACEBOOK_ADS",
      "name": "aspen-creek",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416"
    },
    {
      "lead_collector_id": "0198aa46-f7a6-77c2-bce8-f678c61f101e",
      "lead_source": "LANDING_PAGE",
      "name": "aspen-creek",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "generator",
      "page_item_url": "aspen-creek-pet-friendly-apartments-kirkland",
      "search_query": "pet-friendly apartments with dog park in Kirkland WA",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Kirkland, WA",
      "h2_subtitle": "Explore pet-friendly apartments with a dog park in Kirkland, WA. Aspen Creek offers a welcoming community for both you and your pets.",
      "page_copy": "Discover the perfect balance of comfort and convenience at Aspen Creek, where pet-friendly apartments with a dog park await you in Kirkland, WA. Our spacious one, two, and three-bedroom floor plans are designed to accommodate your lifestyle, featuring amenities that cater to both you and your furry friends.\n\nAt Aspen Creek, you and your pets will feel right at home with access to our inviting community spaces. Enjoy the resident lounge, coffee station, and participate in our vibrant social events while your pet enjoys the on-site dog park. Embrace the joy of living in a community that values pet owners and provides the perfect setting for everyone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, large windows, and plush seating.",
        "public_id": "019d019f-9089-77a6-b8cd-3c0c4b4973d5",
        "storage_key": "property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Kirkland, WA",
      "seo_description": "Discover pet-friendly apartments with a dog park in Kirkland, WA at Aspen Creek. Enjoy spacious living with amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "generator",
      "page_item_url": "aspen-creek-apartments-in-unit-laundry-north-rose-hill",
      "search_query": "apartments with in-unit laundry near North Rose Hill",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Kirkland",
      "h2_subtitle": "Experience the convenience of apartments with in-unit laundry near North Rose Hill. Aspen Creek offers thoughtfully designed homes.",
      "page_copy": "Welcome to Aspen Creek, where modern living meets convenience with our apartments featuring in-unit laundry near North Rose Hill in Kirkland, WA. Our community provides you with a variety of spacious floor plans, ensuring that your new home meets all your comfort needs.\n\nLiving at Aspen Creek means you don’t have to compromise on functionality or style. Enjoy in-unit laundry facilities that make everyday life easier while taking advantage of our premium community amenities like the resident lounge and coffee station. At Aspen Creek, we're dedicated to offering a lifestyle that perfectly blends convenience and comfort, just moments from the vibrant heart of North Rose Hill.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, large windows, and plush seating.",
        "public_id": "019d019f-9089-77a6-b8cd-3c0c4b4973d5",
        "storage_key": "property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Kirkland",
      "seo_description": "Discover apartments with in-unit laundry near North Rose Hill at Aspen Creek. Enjoy convenient, modern living in Kirkland's vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "generator",
      "page_item_url": "aspen-creek-kirkland-apartments-with-pool",
      "search_query": "Kirkland apartments with pool access and resident lounge",
      "category": "Amenity",
      "h1_title": "Kirkland Apartments with Pool",
      "h2_subtitle": "Discover Kirkland apartments with pool access and a resident lounge. Aspen Creek offers an inviting community with exceptional amenities.",
      "page_copy": "Experience the perfect blend of relaxation and social ambiance at Aspen Creek, offering Kirkland apartments with pool access and a welcoming resident lounge. Our community is designed to enhance your lifestyle, providing spacious one, two, and three-bedroom floor plans that cater to your every need.\n\nAt Aspen Creek, poolside relaxation and community events are at your doorstep. Enjoy a refreshing dip in the pool or savor conversations in the resident lounge, all while taking advantage of additional amenities like a coffee station and planned social activities. At Aspen Creek, we focus on creating a vibrant, engaging environment for all residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, large windows, and plush seating.",
        "public_id": "019d019f-9089-77a6-b8cd-3c0c4b4973d5",
        "storage_key": "property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kirkland Apartments with Pool Access",
      "seo_description": "Explore Kirkland apartments with pool access at Aspen Creek. Enjoy a resident lounge and more, providing a vibrant living experience in the heart of Kirkland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "generator",
      "page_item_url": "aspen-creek-luxury-apartments-vaulted-ceilings-98033",
      "search_query": "luxury apartments with vaulted ceilings in 98033",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Vaulted Ceilings",
      "h2_subtitle": "Find luxury apartments with vaulted ceilings in 98033 at Aspen Creek. Experience elegant living with spacious designs and premium finishes.",
      "page_copy": "Step into elegance and style at Aspen Creek, where luxury apartments with vaulted ceilings in the 98033 area redefine sophisticated living. Our community offers beautifully designed homes with spacious interiors and elegant finishes, catering to those who desire a higher standard of living.\n\nAt Aspen Creek, vaulted ceilings elevate your living experience, providing an airy, open feel that enhances the sense of luxury in your home. Complemented by exceptional amenities like a resident lounge and a coffee station, our community ensures a lifestyle that’s as convenient as it is stylish. Come discover your perfect luxury retreat in Kirkland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, large windows, and plush seating.",
        "public_id": "019d019f-9089-77a6-b8cd-3c0c4b4973d5",
        "storage_key": "property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Vaulted Ceilings",
      "seo_description": "Discover luxury apartments with vaulted ceilings in 98033 at Aspen Creek. Enjoy sophisticated living with spacious designs and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "generator",
      "page_item_url": "aspen-creek-energy-efficient-apartments-waterfront-kirkland",
      "search_query": "energy-efficient apartments near waterfront in Kirkland",
      "category": "Amenity",
      "h1_title": "Energy-Efficient Apartments Near Waterfront",
      "h2_subtitle": "Explore energy-efficient apartments near the waterfront in Kirkland at Aspen Creek. Enjoy sustainable living in a prime location.",
      "page_copy": "Discover the benefits of sustainable living at Aspen Creek, offering energy-efficient apartments near the beautiful waterfront of Kirkland. Our community is designed with the environment in mind, ensuring that every aspect of your home contributes to a greener lifestyle.\n\nLocated just a short distance from Kirkland's stunning waterfront, Aspen Creek provides not only a convenient location but also a commitment to energy efficiency. Our thoughtfully designed homes feature modern amenities and are part of a community driven by sustainability. Enjoy living in a place where comfort and eco-consciousness harmoniously coexist.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, large windows, and plush seating.",
        "public_id": "019d019f-9089-77a6-b8cd-3c0c4b4973d5",
        "storage_key": "property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy-Efficient Apartments in Kirkland",
      "seo_description": "Explore energy-efficient apartments near Kirkland's waterfront at Aspen Creek, offering sustainable living in a prime location with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "generator",
      "page_item_url": "aspen-creek-1-bedroom-apartments-north-rose-hill",
      "search_query": "1 bedroom apartments north rose hill",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in North Rose Hill",
      "h2_subtitle": "Discover charming 1 bedroom apartments in North Rose Hill. Aspen Creek offers modern comforts in a serene setting.",
      "page_copy": "Looking for the perfect cozy retreat? Aspen Creek features charming 1 bedroom apartments in North Rose Hill, ideal for those seeking style and convenience in a peaceful environment. Our spacious layouts are designed for comfort, making them perfect for individuals or couples looking for a home-like feel.\n\nLocated in the heart of North Rose Hill, Aspen Creek offers more than just a prime location. With amenities such as a resident lounge and social activities, our community fosters a welcoming atmosphere that’s perfect for mingling with neighbors or relaxing after a day in Kirkland. Embrace modern living at Aspen Creek today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, large windows, and plush seating.",
        "public_id": "019d019f-9089-77a6-b8cd-3c0c4b4973d5",
        "storage_key": "property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in North Rose Hill",
      "seo_description": "Discover 1 bedroom apartments in North Rose Hill at Aspen Creek. Enjoy modern comforts and a serene setting in Kirkland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "generator",
      "page_item_url": "aspen-creek-2-bedroom-apartments-kirkland-wa",
      "search_query": "2 bedroom apartments kirkland wa",
      "category": "Floorplan",
      "h1_title": "Spacious 2 Bedroom Apartments in Kirkland",
      "h2_subtitle": "Explore beautiful 2 bedroom apartments in Kirkland, WA at Aspen Creek. Designed for comfort and style, these homes are perfect for any lifestyle.",
      "page_copy": "Aspen Creek invites you to discover our spacious 2 bedroom apartments in Kirkland, WA, where modern design meets comfortable living. Each apartment is thoughtfully crafted to provide ample space and a welcoming ambiance, ideal for small families, roommates, or anyone in need of extra room.\n\nLocated conveniently in Kirkland, Aspen Creek combines urban convenience with a suburban feel. Residents enjoy access to great amenities, including a resident lounge and coffee station, perfect for socializing or relaxing at home. Come and see why our community is the best choice for 2 bedroom living in this vibrant city.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, large windows, and plush seating.",
        "public_id": "019d019f-9089-77a6-b8cd-3c0c4b4973d5",
        "storage_key": "property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious 2 Bedroom Apartments in Kirkland",
      "seo_description": "Explore 2 bedroom apartments in Kirkland, WA at Aspen Creek, offering spacious layouts and modern amenities for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5672714597564416",
      "source": "generator",
      "page_item_url": "aspen-creek-3-bedroom-apartments-near-98033",
      "search_query": "3 bedroom apartments near 98033",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 98033",
      "h2_subtitle": "Discover spacious 3 bedroom apartments near the 98033 area. Aspen Creek offers a perfect blend of comfort and convenience.",
      "page_copy": "Aspen Creek offers beautiful 3 bedroom apartments near the 98033 area, designed to cater to your lifestyle needs with plenty of space and modern comforts. Our residences provide the perfect setting for families or those requiring extra room to live comfortably.\n\nSituated in Kirkland, these apartments are just a stone's throw away from the vibrant local offerings, making daily conveniences and exciting activities easily accessible. With amenities like vaulted ceilings in select homes, Aspen Creek ensures that each day spent here is both comfortable and stylish. Experience the ideal blend of serenity and accessibility at our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
      "featured_image_media": {
        "alt_text": "Living room with fireplace, large windows, and plush seating.",
        "public_id": "019d019f-9089-77a6-b8cd-3c0c4b4973d5",
        "storage_key": "property/5672714597564416/019d019f-9089-77a6-b8cd-3c0c4b4973d5.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 98033",
      "seo_description": "Find spacious 3 bedroom apartments near 98033 at Aspen Creek. Enjoy modern comforts and a convenient Kirkland location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4718"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147445136"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4252564010"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WLJ3SLQK"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "8042e20f-1344-40e7-b2a2-6761a371fa3e"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/6460cbf1-916a-4d53-a8a2-207c119fde8c/app.js?property=6460cbf1-916a-4d53-a8a2-207c119fde8c&propertyName=Aspen+Creek&channelUuid=c248ed71-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjlOZFNVQ0oxQWxNdk5HenlWUFQ5cWc9PSIsInZhbHVlIjoiaTNoZS9wa0d4V25EMXlJWThJNXdIdz09IiwibWFjIjoiNDI1MDRhMzEwYTBmNWNhZDA5NWUyYWZhMjI0N2Q5MjQzNGY4MmJjYzMyZGM5MzQyNzMxYTA3MzE0OTk4NDYzMiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4718",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147445136",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4252564010",
  "custom_google_gtm_id": "GTM-WLJ3SLQK",
  "custom_rollout_phase": "Phase 1",
  "custom_rentgrata_token": "8042e20f-1344-40e7-b2a2-6761a371fa3e",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/6460cbf1-916a-4d53-a8a2-207c119fde8c/app.js?property=6460cbf1-916a-4d53-a8a2-207c119fde8c&propertyName=Aspen+Creek&channelUuid=c248ed71-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjlOZFNVQ0oxQWxNdk5HenlWUFQ5cWc9PSIsInZhbHVlIjoiaTNoZS9wa0d4V25EMXlJWThJNXdIdz09IiwibWFjIjoiNDI1MDRhMzEwYTBmNWNhZDA5NWUyYWZhMjI0N2Q5MjQzNGY4MmJjYzMyZGM5MzQyNzMxYTA3MzE0OTk4NDYzMiJ9",
  "custom_audioeye_site_id": "3ad36ec9-5728-4c87-beb7-49cd55846104",
  "custom_audioeye_site_hash": "5ad781251f6a4be8c40216373d744490"
};

export const generatedAt = '2026-10-27T17:07:15.681Z';
